var map = {
	"./en.png": "9996",
	"./flat/16/Abkhazia.png": "aa2b",
	"./flat/16/Afghanistan.png": "622c",
	"./flat/16/Aland.png": "44bc",
	"./flat/16/Albania.png": "6854",
	"./flat/16/Algeria.png": "c9a4",
	"./flat/16/American-Samoa.png": "973c",
	"./flat/16/Andorra.png": "e6c2",
	"./flat/16/Angola.png": "a513",
	"./flat/16/Anguilla.png": "db28",
	"./flat/16/Antarctica.png": "dd3e",
	"./flat/16/Antigua-and-Barbuda.png": "5455",
	"./flat/16/Argentina.png": "004e",
	"./flat/16/Armenia.png": "d17f",
	"./flat/16/Aruba.png": "4233",
	"./flat/16/Australia.png": "3d82",
	"./flat/16/Austria.png": "4b4c",
	"./flat/16/Azerbaijan.png": "3ae3",
	"./flat/16/Bahamas.png": "ba95",
	"./flat/16/Bahrain.png": "c5b4",
	"./flat/16/Bangladesh.png": "8776",
	"./flat/16/Barbados.png": "29b0",
	"./flat/16/Basque-Country.png": "3d61",
	"./flat/16/Belarus.png": "270e",
	"./flat/16/Belgium.png": "296f",
	"./flat/16/Belize.png": "696f",
	"./flat/16/Benin.png": "4a4a",
	"./flat/16/Bermuda.png": "3967",
	"./flat/16/Bhutan.png": "fc37",
	"./flat/16/Bolivia.png": "a873",
	"./flat/16/Bosnia-and-Herzegovina.png": "2d55",
	"./flat/16/Botswana.png": "a4a6",
	"./flat/16/Brazil.png": "a632",
	"./flat/16/British-Antarctic-Territory.png": "27fa",
	"./flat/16/British-Virgin-Islands.png": "9548",
	"./flat/16/Brunei.png": "11d3",
	"./flat/16/Bulgaria.png": "9410",
	"./flat/16/Burkina-Faso.png": "cf42",
	"./flat/16/Burundi.png": "6662",
	"./flat/16/Cambodia.png": "f88b",
	"./flat/16/Cameroon.png": "3fd7",
	"./flat/16/Canada.png": "60cf",
	"./flat/16/Canary-Islands.png": "a125",
	"./flat/16/Cape-Verde.png": "d05d",
	"./flat/16/Cayman-Islands.png": "9205",
	"./flat/16/Central-African-Republic.png": "6c2b",
	"./flat/16/Chad.png": "bcc1",
	"./flat/16/Chile.png": "818b",
	"./flat/16/China.png": "6e27",
	"./flat/16/Christmas-Island.png": "1b4b",
	"./flat/16/Cocos-Keeling-Islands.png": "9b23",
	"./flat/16/Colombia.png": "1568",
	"./flat/16/Commonwealth.png": "64ee",
	"./flat/16/Comoros.png": "6cbd",
	"./flat/16/Cook-Islands.png": "af60",
	"./flat/16/Costa-Rica.png": "27c9",
	"./flat/16/Cote-dIvoire.png": "bb14",
	"./flat/16/Croatia.png": "d771",
	"./flat/16/Cuba.png": "d086",
	"./flat/16/Curacao.png": "023c",
	"./flat/16/Cyprus.png": "6386",
	"./flat/16/Czech-Republic.png": "2312",
	"./flat/16/Democratic-Republic-of-the-Congo.png": "c63c",
	"./flat/16/Denmark.png": "1280",
	"./flat/16/Djibouti.png": "436d",
	"./flat/16/Dominica.png": "b6e1",
	"./flat/16/Dominican-Republic.png": "9dee",
	"./flat/16/East-Timor.png": "fc02",
	"./flat/16/Ecuador.png": "b557",
	"./flat/16/Egypt.png": "ec3e",
	"./flat/16/El-Salvador.png": "2c48",
	"./flat/16/England.png": "66f0",
	"./flat/16/Equatorial-Guinea.png": "3a9f",
	"./flat/16/Eritrea.png": "fff7",
	"./flat/16/Estonia.png": "6843",
	"./flat/16/Ethiopia.png": "7e9d",
	"./flat/16/European-Union.png": "db9e",
	"./flat/16/Falkland-Islands.png": "6bf7",
	"./flat/16/Faroes.png": "ab3e",
	"./flat/16/Fiji.png": "e6a7",
	"./flat/16/Finland.png": "8468",
	"./flat/16/France.png": "be24",
	"./flat/16/French-Polynesia.png": "980d",
	"./flat/16/French-Southern-Territories.png": "2549",
	"./flat/16/Gabon.png": "e1d0",
	"./flat/16/Gambia.png": "6f47",
	"./flat/16/Georgia.png": "eebd",
	"./flat/16/Germany.png": "437b",
	"./flat/16/Ghana.png": "66a0",
	"./flat/16/Gibraltar.png": "f6ee",
	"./flat/16/GoSquared.png": "4a3b",
	"./flat/16/Greece.png": "648e",
	"./flat/16/Greenland.png": "55ee",
	"./flat/16/Grenada.png": "3e70",
	"./flat/16/Guam.png": "0835",
	"./flat/16/Guatemala.png": "152d",
	"./flat/16/Guernsey.png": "b593",
	"./flat/16/Guinea-Bissau.png": "e72f",
	"./flat/16/Guinea.png": "25d5",
	"./flat/16/Guyana.png": "efd6",
	"./flat/16/Haiti.png": "84b8",
	"./flat/16/Honduras.png": "f890",
	"./flat/16/Hong-Kong.png": "5ec3",
	"./flat/16/Hungary.png": "a2ad",
	"./flat/16/Iceland.png": "c346",
	"./flat/16/India.png": "fc2e",
	"./flat/16/Indonesia.png": "c081",
	"./flat/16/Iran.png": "cd68",
	"./flat/16/Iraq.png": "c4fd",
	"./flat/16/Ireland.png": "f6a2",
	"./flat/16/Isle-of-Man.png": "968a",
	"./flat/16/Israel.png": "7317",
	"./flat/16/Italy.png": "505f",
	"./flat/16/Jamaica.png": "dc86",
	"./flat/16/Japan.png": "ff95",
	"./flat/16/Jersey.png": "f425",
	"./flat/16/Jordan.png": "455b",
	"./flat/16/Kazakhstan.png": "9dbd",
	"./flat/16/Kenya.png": "89a1",
	"./flat/16/Kiribati.png": "ceb3",
	"./flat/16/Kosovo.png": "173f",
	"./flat/16/Kuwait.png": "2d94",
	"./flat/16/Kyrgyzstan.png": "003b",
	"./flat/16/Laos.png": "c2f7",
	"./flat/16/Latvia.png": "7556",
	"./flat/16/Lebanon.png": "be4f",
	"./flat/16/Lesotho.png": "56d5",
	"./flat/16/Liberia.png": "c7ee",
	"./flat/16/Libya.png": "1d80",
	"./flat/16/Liechtenstein.png": "19a1",
	"./flat/16/Lithuania.png": "b25e",
	"./flat/16/Luxembourg.png": "8d73",
	"./flat/16/Macau.png": "6ecb",
	"./flat/16/Macedonia.png": "d71d",
	"./flat/16/Madagascar.png": "e773",
	"./flat/16/Malawi.png": "c34d",
	"./flat/16/Malaysia.png": "3f12",
	"./flat/16/Maldives.png": "f825",
	"./flat/16/Mali.png": "f949",
	"./flat/16/Malta.png": "152b",
	"./flat/16/Mars.png": "236c",
	"./flat/16/Marshall-Islands.png": "5749",
	"./flat/16/Martinique.png": "ef22",
	"./flat/16/Mauritania.png": "18f1",
	"./flat/16/Mauritius.png": "1ff7",
	"./flat/16/Mayotte.png": "c0b7",
	"./flat/16/Mexico.png": "6145",
	"./flat/16/Micronesia.png": "34e6",
	"./flat/16/Moldova.png": "7259",
	"./flat/16/Monaco.png": "bcb4",
	"./flat/16/Mongolia.png": "4c91",
	"./flat/16/Montenegro.png": "ad13",
	"./flat/16/Montserrat.png": "67f5",
	"./flat/16/Morocco.png": "e5d0",
	"./flat/16/Mozambique.png": "6a31",
	"./flat/16/Myanmar.png": "dd62",
	"./flat/16/NATO.png": "a7f4",
	"./flat/16/Nagorno-Karabakh.png": "d6b8",
	"./flat/16/Namibia.png": "1127",
	"./flat/16/Nauru.png": "e3fc",
	"./flat/16/Nepal.png": "f651",
	"./flat/16/Netherlands-Antilles.png": "3bd0",
	"./flat/16/Netherlands.png": "c15c",
	"./flat/16/New-Caledonia.png": "e605",
	"./flat/16/New-Zealand.png": "6f80",
	"./flat/16/Nicaragua.png": "1441",
	"./flat/16/Niger.png": "796a",
	"./flat/16/Nigeria.png": "0418",
	"./flat/16/Niue.png": "e823",
	"./flat/16/Norfolk-Island.png": "2220",
	"./flat/16/North-Korea.png": "8627",
	"./flat/16/Northern-Cyprus.png": "d7ad",
	"./flat/16/Northern-Mariana-Islands.png": "f1fa",
	"./flat/16/Norway.png": "8f01",
	"./flat/16/Olympics.png": "245f",
	"./flat/16/Oman.png": "5075",
	"./flat/16/Pakistan.png": "991f",
	"./flat/16/Palau.png": "3227",
	"./flat/16/Palestine.png": "7d51",
	"./flat/16/Panama.png": "aed2",
	"./flat/16/Papua-New-Guinea.png": "d88c",
	"./flat/16/Paraguay.png": "4e67",
	"./flat/16/Peru.png": "cac1a",
	"./flat/16/Philippines.png": "c8c3",
	"./flat/16/Pitcairn-Islands.png": "31b9",
	"./flat/16/Poland.png": "bf4f",
	"./flat/16/Portugal.png": "455f",
	"./flat/16/Puerto-Rico.png": "16fd",
	"./flat/16/Qatar.png": "2469",
	"./flat/16/Red-Cross.png": "d02c8",
	"./flat/16/Republic-of-the-Congo.png": "7209",
	"./flat/16/Romania.png": "1166",
	"./flat/16/Russia.png": "e85a",
	"./flat/16/Rwanda.png": "93e3",
	"./flat/16/Saint-Barthelemy.png": "73ba",
	"./flat/16/Saint-Helena.png": "a613",
	"./flat/16/Saint-Kitts-and-Nevis.png": "eeaa",
	"./flat/16/Saint-Lucia.png": "81ec",
	"./flat/16/Saint-Martin.png": "299a",
	"./flat/16/Saint-Vincent-and-the-Grenadines.png": "9bc1",
	"./flat/16/Samoa.png": "9216",
	"./flat/16/San-Marino.png": "bf2b",
	"./flat/16/Sao-Tome-and-Principe.png": "6b84",
	"./flat/16/Saudi-Arabia.png": "31d7",
	"./flat/16/Scotland.png": "1556",
	"./flat/16/Senegal.png": "4c7e",
	"./flat/16/Serbia.png": "84db",
	"./flat/16/Seychelles.png": "7985",
	"./flat/16/Sierra-Leone.png": "8807",
	"./flat/16/Singapore.png": "c460",
	"./flat/16/Slovakia.png": "d561",
	"./flat/16/Slovenia.png": "86d2",
	"./flat/16/Solomon-Islands.png": "1bda",
	"./flat/16/Somalia.png": "6484",
	"./flat/16/Somaliland.png": "375b",
	"./flat/16/South-Africa.png": "5356",
	"./flat/16/South-Georgia-and-the-South-Sandwich-Islands.png": "803e",
	"./flat/16/South-Korea.png": "c6a8",
	"./flat/16/South-Ossetia.png": "9bd6",
	"./flat/16/South-Sudan.png": "9df8",
	"./flat/16/Spain.png": "0baf",
	"./flat/16/Sri-Lanka.png": "a051",
	"./flat/16/Sudan.png": "507d",
	"./flat/16/Suriname.png": "2810",
	"./flat/16/Swaziland.png": "6b70",
	"./flat/16/Sweden.png": "bf66",
	"./flat/16/Switzerland.png": "7f16",
	"./flat/16/Syria.png": "3065",
	"./flat/16/Taiwan.png": "8bf9",
	"./flat/16/Tajikistan.png": "8d52",
	"./flat/16/Tanzania.png": "7d3e",
	"./flat/16/Thailand.png": "5ec8",
	"./flat/16/Togo.png": "46e8",
	"./flat/16/Tokelau.png": "5ab5",
	"./flat/16/Tonga.png": "583f",
	"./flat/16/Trinidad-and-Tobago.png": "1edd",
	"./flat/16/Tunisia.png": "03fa",
	"./flat/16/Turkey.png": "90d4",
	"./flat/16/Turkmenistan.png": "3832",
	"./flat/16/Turks-and-Caicos-Islands.png": "a870",
	"./flat/16/Tuvalu.png": "41a1",
	"./flat/16/US-Virgin-Islands.png": "c238",
	"./flat/16/Uganda.png": "7458",
	"./flat/16/Ukraine.png": "78cd",
	"./flat/16/United-Arab-Emirates.png": "830d",
	"./flat/16/United-Kingdom.png": "7d0f",
	"./flat/16/United-Nations.png": "b57e",
	"./flat/16/United-States.png": "79485",
	"./flat/16/Unknown.png": "99ba",
	"./flat/16/Uruguay.png": "fe2c",
	"./flat/16/Uzbekistan.png": "0f51",
	"./flat/16/Vanuatu.png": "ce35",
	"./flat/16/Vatican-City.png": "eac3",
	"./flat/16/Venezuela.png": "26bb",
	"./flat/16/Vietnam.png": "c73a",
	"./flat/16/Wales.png": "13a9",
	"./flat/16/Wallis-And-Futuna.png": "6d0e",
	"./flat/16/Western-Sahara.png": "ef06",
	"./flat/16/Yemen.png": "b236",
	"./flat/16/Zambia.png": "298d",
	"./flat/16/Zimbabwe.png": "7e13",
	"./flat/24/Abkhazia.png": "945f",
	"./flat/24/Afghanistan.png": "4b59",
	"./flat/24/Aland.png": "83a3",
	"./flat/24/Albania.png": "f3fc",
	"./flat/24/Algeria.png": "9311",
	"./flat/24/American-Samoa.png": "5741",
	"./flat/24/Andorra.png": "6299",
	"./flat/24/Angola.png": "ca85",
	"./flat/24/Anguilla.png": "d95d",
	"./flat/24/Antarctica.png": "07e8",
	"./flat/24/Antigua-and-Barbuda.png": "71d5",
	"./flat/24/Argentina.png": "011b",
	"./flat/24/Armenia.png": "56db",
	"./flat/24/Aruba.png": "a665",
	"./flat/24/Australia.png": "efd4",
	"./flat/24/Austria.png": "5ad7",
	"./flat/24/Azerbaijan.png": "58a1",
	"./flat/24/Bahamas.png": "8cdd",
	"./flat/24/Bahrain.png": "cb33",
	"./flat/24/Bangladesh.png": "2ad3",
	"./flat/24/Barbados.png": "de7a",
	"./flat/24/Basque-Country.png": "8394",
	"./flat/24/Belarus.png": "1faf",
	"./flat/24/Belgium.png": "8d37",
	"./flat/24/Belize.png": "9a92",
	"./flat/24/Benin.png": "259f",
	"./flat/24/Bermuda.png": "e48b",
	"./flat/24/Bhutan.png": "cd34",
	"./flat/24/Bolivia.png": "45e8",
	"./flat/24/Bosnia-and-Herzegovina.png": "5d3e",
	"./flat/24/Botswana.png": "2821",
	"./flat/24/Brazil.png": "602d",
	"./flat/24/British-Antarctic-Territory.png": "b1b3",
	"./flat/24/British-Virgin-Islands.png": "0e00",
	"./flat/24/Brunei.png": "a8f6",
	"./flat/24/Bulgaria.png": "50b2",
	"./flat/24/Burkina-Faso.png": "7c54",
	"./flat/24/Burundi.png": "8758",
	"./flat/24/Cambodia.png": "801f",
	"./flat/24/Cameroon.png": "17a0",
	"./flat/24/Canada.png": "82de",
	"./flat/24/Canary-Islands.png": "fa3f",
	"./flat/24/Cape-Verde.png": "4c03",
	"./flat/24/Cayman-Islands.png": "30c4",
	"./flat/24/Central-African-Republic.png": "9944",
	"./flat/24/Chad.png": "ed67",
	"./flat/24/Chile.png": "f1fa8",
	"./flat/24/China.png": "89cd",
	"./flat/24/Christmas-Island.png": "b4ce",
	"./flat/24/Cocos-Keeling-Islands.png": "121a",
	"./flat/24/Colombia.png": "e8b4",
	"./flat/24/Commonwealth.png": "c6fd",
	"./flat/24/Comoros.png": "3451",
	"./flat/24/Cook-Islands.png": "b23f",
	"./flat/24/Costa-Rica.png": "11fc",
	"./flat/24/Cote-dIvoire.png": "4cb6",
	"./flat/24/Croatia.png": "c01a",
	"./flat/24/Cuba.png": "9a0a",
	"./flat/24/Curacao.png": "740e",
	"./flat/24/Cyprus.png": "f707",
	"./flat/24/Czech-Republic.png": "6e39",
	"./flat/24/Democratic-Republic-of-the-Congo.png": "5462",
	"./flat/24/Denmark.png": "0b9c",
	"./flat/24/Djibouti.png": "7bff",
	"./flat/24/Dominica.png": "3fab",
	"./flat/24/Dominican-Republic.png": "43d7",
	"./flat/24/East-Timor.png": "f3c5",
	"./flat/24/Ecuador.png": "405c",
	"./flat/24/Egypt.png": "3f6a",
	"./flat/24/El-Salvador.png": "ac23",
	"./flat/24/England.png": "1737",
	"./flat/24/Equatorial-Guinea.png": "efb1",
	"./flat/24/Eritrea.png": "211d",
	"./flat/24/Estonia.png": "0d47",
	"./flat/24/Ethiopia.png": "a862",
	"./flat/24/European-Union.png": "2833",
	"./flat/24/Falkland-Islands.png": "6ad1",
	"./flat/24/Faroes.png": "4fc6",
	"./flat/24/Fiji.png": "32c0",
	"./flat/24/Finland.png": "cc7a",
	"./flat/24/France.png": "9d13",
	"./flat/24/French-Polynesia.png": "d2b7",
	"./flat/24/French-Southern-Territories.png": "8cb5",
	"./flat/24/Gabon.png": "2013",
	"./flat/24/Gambia.png": "ee55",
	"./flat/24/Georgia.png": "efca",
	"./flat/24/Germany.png": "2eeb",
	"./flat/24/Ghana.png": "1a08",
	"./flat/24/Gibraltar.png": "a2b2",
	"./flat/24/GoSquared.png": "5b20",
	"./flat/24/Greece.png": "54c2",
	"./flat/24/Greenland.png": "f5aa",
	"./flat/24/Grenada.png": "a5d6",
	"./flat/24/Guam.png": "65c3",
	"./flat/24/Guatemala.png": "6d46",
	"./flat/24/Guernsey.png": "b7dd",
	"./flat/24/Guinea-Bissau.png": "baa0",
	"./flat/24/Guinea.png": "b104",
	"./flat/24/Guyana.png": "2467",
	"./flat/24/Haiti.png": "becb",
	"./flat/24/Honduras.png": "e0ed",
	"./flat/24/Hong-Kong.png": "60e5",
	"./flat/24/Hungary.png": "946d",
	"./flat/24/Iceland.png": "6200",
	"./flat/24/India.png": "5254",
	"./flat/24/Indonesia.png": "0a8b",
	"./flat/24/Iran.png": "f1f6",
	"./flat/24/Iraq.png": "8c36",
	"./flat/24/Ireland.png": "0748",
	"./flat/24/Isle-of-Man.png": "3091",
	"./flat/24/Israel.png": "d800",
	"./flat/24/Italy.png": "deb9",
	"./flat/24/Jamaica.png": "12a0",
	"./flat/24/Japan.png": "7ecc",
	"./flat/24/Jersey.png": "fc39",
	"./flat/24/Jordan.png": "a7b4",
	"./flat/24/Kazakhstan.png": "293b",
	"./flat/24/Kenya.png": "6a1a",
	"./flat/24/Kiribati.png": "9272",
	"./flat/24/Kosovo.png": "ea82",
	"./flat/24/Kuwait.png": "5d46",
	"./flat/24/Kyrgyzstan.png": "a087",
	"./flat/24/Laos.png": "6e38",
	"./flat/24/Latvia.png": "7b7f",
	"./flat/24/Lebanon.png": "10e4",
	"./flat/24/Lesotho.png": "3ea7",
	"./flat/24/Liberia.png": "781f",
	"./flat/24/Libya.png": "dc17",
	"./flat/24/Liechtenstein.png": "6ced",
	"./flat/24/Lithuania.png": "f963",
	"./flat/24/Luxembourg.png": "920d",
	"./flat/24/Macau.png": "98f1",
	"./flat/24/Macedonia.png": "10f1",
	"./flat/24/Madagascar.png": "ffaa",
	"./flat/24/Malawi.png": "8767",
	"./flat/24/Malaysia.png": "95f5",
	"./flat/24/Maldives.png": "5241",
	"./flat/24/Mali.png": "f661",
	"./flat/24/Malta.png": "b2b5",
	"./flat/24/Mars.png": "04ff",
	"./flat/24/Marshall-Islands.png": "ecb9",
	"./flat/24/Martinique.png": "7b12",
	"./flat/24/Mauritania.png": "a6cd",
	"./flat/24/Mauritius.png": "cbed",
	"./flat/24/Mayotte.png": "c19f",
	"./flat/24/Mexico.png": "73c6",
	"./flat/24/Micronesia.png": "3fb8",
	"./flat/24/Moldova.png": "8bfe",
	"./flat/24/Monaco.png": "1b14",
	"./flat/24/Mongolia.png": "6682",
	"./flat/24/Montenegro.png": "6b0b",
	"./flat/24/Montserrat.png": "fdc7",
	"./flat/24/Morocco.png": "294e",
	"./flat/24/Mozambique.png": "3e4d",
	"./flat/24/Myanmar.png": "2548",
	"./flat/24/NATO.png": "90fd",
	"./flat/24/Nagorno-Karabakh.png": "e91f",
	"./flat/24/Namibia.png": "2540",
	"./flat/24/Nauru.png": "0c61",
	"./flat/24/Nepal.png": "0c13",
	"./flat/24/Netherlands-Antilles.png": "d748",
	"./flat/24/Netherlands.png": "69a0",
	"./flat/24/New-Caledonia.png": "aadc",
	"./flat/24/New-Zealand.png": "f008",
	"./flat/24/Nicaragua.png": "0787",
	"./flat/24/Niger.png": "1d27",
	"./flat/24/Nigeria.png": "9b59",
	"./flat/24/Niue.png": "31a6",
	"./flat/24/Norfolk-Island.png": "5608",
	"./flat/24/North-Korea.png": "3f3a",
	"./flat/24/Northern-Cyprus.png": "6202",
	"./flat/24/Northern-Mariana-Islands.png": "6537",
	"./flat/24/Norway.png": "61d6",
	"./flat/24/Olympics.png": "fed9",
	"./flat/24/Oman.png": "3248",
	"./flat/24/Pakistan.png": "1d08",
	"./flat/24/Palau.png": "0602",
	"./flat/24/Palestine.png": "89d7",
	"./flat/24/Panama.png": "a339",
	"./flat/24/Papua-New-Guinea.png": "c5d7",
	"./flat/24/Paraguay.png": "97c1",
	"./flat/24/Peru.png": "650d",
	"./flat/24/Philippines.png": "5ebe",
	"./flat/24/Pitcairn-Islands.png": "b567",
	"./flat/24/Poland.png": "da84",
	"./flat/24/Portugal.png": "650e",
	"./flat/24/Puerto-Rico.png": "de2c",
	"./flat/24/Qatar.png": "402e",
	"./flat/24/Red-Cross.png": "f574",
	"./flat/24/Republic-of-the-Congo.png": "9a2c",
	"./flat/24/Romania.png": "2aebe",
	"./flat/24/Russia.png": "4101",
	"./flat/24/Rwanda.png": "4cd2",
	"./flat/24/Saint-Barthelemy.png": "6449",
	"./flat/24/Saint-Helena.png": "b7ec",
	"./flat/24/Saint-Kitts-and-Nevis.png": "d3ea",
	"./flat/24/Saint-Lucia.png": "a72e",
	"./flat/24/Saint-Martin.png": "250c",
	"./flat/24/Saint-Vincent-and-the-Grenadines.png": "22df",
	"./flat/24/Samoa.png": "1d9d",
	"./flat/24/San-Marino.png": "7a82",
	"./flat/24/Sao-Tome-and-Principe.png": "211c",
	"./flat/24/Saudi-Arabia.png": "d35b",
	"./flat/24/Scotland.png": "773f",
	"./flat/24/Senegal.png": "8173",
	"./flat/24/Serbia.png": "939e",
	"./flat/24/Seychelles.png": "a9d3",
	"./flat/24/Sierra-Leone.png": "f452",
	"./flat/24/Singapore.png": "8bfb",
	"./flat/24/Slovakia.png": "ea69",
	"./flat/24/Slovenia.png": "6510",
	"./flat/24/Solomon-Islands.png": "e8f6",
	"./flat/24/Somalia.png": "f6ca",
	"./flat/24/Somaliland.png": "c11f",
	"./flat/24/South-Africa.png": "cf23",
	"./flat/24/South-Georgia-and-the-South-Sandwich-Islands.png": "390f",
	"./flat/24/South-Korea.png": "3c17",
	"./flat/24/South-Ossetia.png": "7bfa",
	"./flat/24/South-Sudan.png": "1e3c",
	"./flat/24/Spain.png": "f3d8",
	"./flat/24/Sri-Lanka.png": "2fb1",
	"./flat/24/Sudan.png": "cded",
	"./flat/24/Suriname.png": "a2f5",
	"./flat/24/Swaziland.png": "a69e",
	"./flat/24/Sweden.png": "0497",
	"./flat/24/Switzerland.png": "b42e",
	"./flat/24/Syria.png": "5d79",
	"./flat/24/Taiwan.png": "ee38",
	"./flat/24/Tajikistan.png": "8ec4",
	"./flat/24/Tanzania.png": "b629",
	"./flat/24/Thailand.png": "1ea7",
	"./flat/24/Togo.png": "5ff3",
	"./flat/24/Tokelau.png": "ff42",
	"./flat/24/Tonga.png": "28c8",
	"./flat/24/Trinidad-and-Tobago.png": "151d",
	"./flat/24/Tunisia.png": "e9f8",
	"./flat/24/Turkey.png": "3526",
	"./flat/24/Turkmenistan.png": "8170",
	"./flat/24/Turks-and-Caicos-Islands.png": "7599",
	"./flat/24/Tuvalu.png": "864d",
	"./flat/24/US-Virgin-Islands.png": "5815",
	"./flat/24/Uganda.png": "8aea",
	"./flat/24/Ukraine.png": "dd29",
	"./flat/24/United-Arab-Emirates.png": "ffb3",
	"./flat/24/United-Kingdom.png": "bd27",
	"./flat/24/United-Nations.png": "f0dd",
	"./flat/24/United-States.png": "b90d",
	"./flat/24/Unknown.png": "3f0d",
	"./flat/24/Uruguay.png": "f5b8",
	"./flat/24/Uzbekistan.png": "d607",
	"./flat/24/Vanuatu.png": "e6f8",
	"./flat/24/Vatican-City.png": "0045",
	"./flat/24/Venezuela.png": "a4a9",
	"./flat/24/Vietnam.png": "1206",
	"./flat/24/Wales.png": "fc07",
	"./flat/24/Wallis-And-Futuna.png": "6122",
	"./flat/24/Western-Sahara.png": "25aa",
	"./flat/24/Yemen.png": "7eb8",
	"./flat/24/Zambia.png": "abbf",
	"./flat/24/Zimbabwe.png": "eb21",
	"./flat/32/Abkhazia.png": "0988",
	"./flat/32/Afghanistan.png": "10c7",
	"./flat/32/Aland.png": "ac5a",
	"./flat/32/Albania.png": "c9bf",
	"./flat/32/Algeria.png": "316c",
	"./flat/32/American-Samoa.png": "02d6",
	"./flat/32/Andorra.png": "1c2b",
	"./flat/32/Angola.png": "ac9b",
	"./flat/32/Anguilla.png": "3fde",
	"./flat/32/Antarctica.png": "b76f",
	"./flat/32/Antigua-and-Barbuda.png": "65df",
	"./flat/32/Argentina.png": "e8d3",
	"./flat/32/Armenia.png": "1b81",
	"./flat/32/Aruba.png": "ebb8",
	"./flat/32/Australia.png": "048e",
	"./flat/32/Austria.png": "416a",
	"./flat/32/Azerbaijan.png": "deec",
	"./flat/32/Bahamas.png": "0477",
	"./flat/32/Bahrain.png": "6375",
	"./flat/32/Bangladesh.png": "dc77",
	"./flat/32/Barbados.png": "9a27",
	"./flat/32/Basque-Country.png": "2b9d",
	"./flat/32/Belarus.png": "99c9",
	"./flat/32/Belgium.png": "b04d",
	"./flat/32/Belize.png": "5409",
	"./flat/32/Benin.png": "f641",
	"./flat/32/Bermuda.png": "be34",
	"./flat/32/Bhutan.png": "4c8c",
	"./flat/32/Bolivia.png": "a503",
	"./flat/32/Bosnia-and-Herzegovina.png": "e91b",
	"./flat/32/Botswana.png": "de02",
	"./flat/32/Brazil.png": "2da9",
	"./flat/32/British-Antarctic-Territory.png": "4bc3",
	"./flat/32/British-Virgin-Islands.png": "6673",
	"./flat/32/Brunei.png": "1539",
	"./flat/32/Bulgaria.png": "5f4c",
	"./flat/32/Burkina-Faso.png": "db7f",
	"./flat/32/Burundi.png": "d938",
	"./flat/32/Cambodia.png": "cebd",
	"./flat/32/Cameroon.png": "722e",
	"./flat/32/Canada.png": "7e5b",
	"./flat/32/Canary-Islands.png": "0323",
	"./flat/32/Cape-Verde.png": "d4ca",
	"./flat/32/Cayman-Islands.png": "990d",
	"./flat/32/Central-African-Republic.png": "3de0",
	"./flat/32/Chad.png": "b14f",
	"./flat/32/Chile.png": "796b",
	"./flat/32/China.png": "d175",
	"./flat/32/Christmas-Island.png": "98b1",
	"./flat/32/Cocos-Keeling-Islands.png": "ffbb",
	"./flat/32/Colombia.png": "14f0",
	"./flat/32/Commonwealth.png": "82a8",
	"./flat/32/Comoros.png": "4a75",
	"./flat/32/Cook-Islands.png": "b429",
	"./flat/32/Costa-Rica.png": "b28b",
	"./flat/32/Cote-dIvoire.png": "bfbb",
	"./flat/32/Croatia.png": "528b",
	"./flat/32/Cuba.png": "608a",
	"./flat/32/Curacao.png": "c788",
	"./flat/32/Cyprus.png": "07b4",
	"./flat/32/Czech-Republic.png": "6702",
	"./flat/32/Democratic-Republic-of-the-Congo.png": "b7c2",
	"./flat/32/Denmark.png": "7e9a",
	"./flat/32/Djibouti.png": "8724",
	"./flat/32/Dominica.png": "4c2d",
	"./flat/32/Dominican-Republic.png": "bb41",
	"./flat/32/East-Timor.png": "5c43",
	"./flat/32/Ecuador.png": "383b",
	"./flat/32/Egypt.png": "ffd3",
	"./flat/32/El-Salvador.png": "684f",
	"./flat/32/England.png": "a567",
	"./flat/32/Equatorial-Guinea.png": "91ab",
	"./flat/32/Eritrea.png": "ed50",
	"./flat/32/Estonia.png": "7fcf",
	"./flat/32/Ethiopia.png": "3c05",
	"./flat/32/European-Union.png": "1070",
	"./flat/32/Falkland-Islands.png": "942a",
	"./flat/32/Faroes.png": "0536",
	"./flat/32/Fiji.png": "425b",
	"./flat/32/Finland.png": "8b2f",
	"./flat/32/France.png": "b8e1",
	"./flat/32/French-Polynesia.png": "6266",
	"./flat/32/French-Southern-Territories.png": "acde",
	"./flat/32/Gabon.png": "762d",
	"./flat/32/Gambia.png": "67f1",
	"./flat/32/Georgia.png": "ace9",
	"./flat/32/Germany.png": "bdad",
	"./flat/32/Ghana.png": "64ad",
	"./flat/32/Gibraltar.png": "0bb6",
	"./flat/32/GoSquared.png": "efc9",
	"./flat/32/Greece.png": "1092",
	"./flat/32/Greenland.png": "6d39",
	"./flat/32/Grenada.png": "a80d",
	"./flat/32/Guam.png": "c0b1",
	"./flat/32/Guatemala.png": "3e30",
	"./flat/32/Guernsey.png": "4f49",
	"./flat/32/Guinea-Bissau.png": "d065",
	"./flat/32/Guinea.png": "3b52",
	"./flat/32/Guyana.png": "0b2f",
	"./flat/32/Haiti.png": "afb0",
	"./flat/32/Honduras.png": "d768",
	"./flat/32/Hong-Kong.png": "b685",
	"./flat/32/Hungary.png": "6682d",
	"./flat/32/Iceland.png": "ac39",
	"./flat/32/India.png": "607b",
	"./flat/32/Indonesia.png": "54a4",
	"./flat/32/Iran.png": "2c6e",
	"./flat/32/Iraq.png": "1c00",
	"./flat/32/Ireland.png": "f6c3",
	"./flat/32/Isle-of-Man.png": "a038",
	"./flat/32/Israel.png": "0d08",
	"./flat/32/Italy.png": "8320",
	"./flat/32/Jamaica.png": "339d",
	"./flat/32/Japan.png": "311a",
	"./flat/32/Jersey.png": "d6e4",
	"./flat/32/Jordan.png": "0002",
	"./flat/32/Kazakhstan.png": "abe0",
	"./flat/32/Kenya.png": "0011",
	"./flat/32/Kiribati.png": "b5b9",
	"./flat/32/Kosovo.png": "c9bf0",
	"./flat/32/Kuwait.png": "c08d",
	"./flat/32/Kyrgyzstan.png": "8312",
	"./flat/32/Laos.png": "1ab2",
	"./flat/32/Latvia.png": "0121",
	"./flat/32/Lebanon.png": "9ab3",
	"./flat/32/Lesotho.png": "1e7e",
	"./flat/32/Liberia.png": "a635",
	"./flat/32/Libya.png": "d61e",
	"./flat/32/Liechtenstein.png": "d87c",
	"./flat/32/Lithuania.png": "308d",
	"./flat/32/Luxembourg.png": "2605",
	"./flat/32/Macau.png": "e965",
	"./flat/32/Macedonia.png": "2e04",
	"./flat/32/Madagascar.png": "138d",
	"./flat/32/Malawi.png": "ab62",
	"./flat/32/Malaysia.png": "af7e",
	"./flat/32/Maldives.png": "c229",
	"./flat/32/Mali.png": "1d3c",
	"./flat/32/Malta.png": "5c66",
	"./flat/32/Mars.png": "6114",
	"./flat/32/Marshall-Islands.png": "334a",
	"./flat/32/Martinique.png": "d50c",
	"./flat/32/Mauritania.png": "6b89",
	"./flat/32/Mauritius.png": "a0c1",
	"./flat/32/Mayotte.png": "9719",
	"./flat/32/Mexico.png": "d254",
	"./flat/32/Micronesia.png": "2ca5",
	"./flat/32/Moldova.png": "5c7d",
	"./flat/32/Monaco.png": "0a12",
	"./flat/32/Mongolia.png": "2cc0",
	"./flat/32/Montenegro.png": "2f7f",
	"./flat/32/Montserrat.png": "9f2e",
	"./flat/32/Morocco.png": "6376",
	"./flat/32/Mozambique.png": "787e",
	"./flat/32/Myanmar.png": "829f",
	"./flat/32/NATO.png": "547d",
	"./flat/32/Nagorno-Karabakh.png": "22f7",
	"./flat/32/Namibia.png": "f173",
	"./flat/32/Nauru.png": "e186",
	"./flat/32/Nepal.png": "771a",
	"./flat/32/Netherlands-Antilles.png": "4b13",
	"./flat/32/Netherlands.png": "c5db",
	"./flat/32/New-Caledonia.png": "254b",
	"./flat/32/New-Zealand.png": "0b27",
	"./flat/32/Nicaragua.png": "7502",
	"./flat/32/Niger.png": "ca6a",
	"./flat/32/Nigeria.png": "d5f5",
	"./flat/32/Niue.png": "bf41",
	"./flat/32/Norfolk-Island.png": "2d5a",
	"./flat/32/North-Korea.png": "5683",
	"./flat/32/Northern-Cyprus.png": "23e7",
	"./flat/32/Northern-Mariana-Islands.png": "9362",
	"./flat/32/Norway.png": "f40d",
	"./flat/32/Olympics.png": "99cdc",
	"./flat/32/Oman.png": "bc90",
	"./flat/32/Pakistan.png": "baf0",
	"./flat/32/Palau.png": "6f8e",
	"./flat/32/Palestine.png": "5218",
	"./flat/32/Panama.png": "ad67",
	"./flat/32/Papua-New-Guinea.png": "cd2f",
	"./flat/32/Paraguay.png": "45b0",
	"./flat/32/Peru.png": "0928",
	"./flat/32/Philippines.png": "236c7",
	"./flat/32/Pitcairn-Islands.png": "14f6",
	"./flat/32/Poland.png": "5450",
	"./flat/32/Portugal.png": "21a5",
	"./flat/32/Puerto-Rico.png": "a7df",
	"./flat/32/Qatar.png": "d82f",
	"./flat/32/Red-Cross.png": "3f58",
	"./flat/32/Republic-of-the-Congo.png": "9044",
	"./flat/32/Romania.png": "9135",
	"./flat/32/Russia.png": "9fe8",
	"./flat/32/Rwanda.png": "4db7",
	"./flat/32/Saint-Barthelemy.png": "a220",
	"./flat/32/Saint-Helena.png": "abd1",
	"./flat/32/Saint-Kitts-and-Nevis.png": "e6cb",
	"./flat/32/Saint-Lucia.png": "edf8",
	"./flat/32/Saint-Martin.png": "f20d",
	"./flat/32/Saint-Vincent-and-the-Grenadines.png": "d08f",
	"./flat/32/Samoa.png": "1fcc",
	"./flat/32/San-Marino.png": "6d6c",
	"./flat/32/Sao-Tome-and-Principe.png": "e9e1",
	"./flat/32/Saudi-Arabia.png": "d842",
	"./flat/32/Scotland.png": "580e",
	"./flat/32/Senegal.png": "d981",
	"./flat/32/Serbia.png": "89c0",
	"./flat/32/Seychelles.png": "c715",
	"./flat/32/Sierra-Leone.png": "520b",
	"./flat/32/Singapore.png": "f7ee",
	"./flat/32/Slovakia.png": "9e71",
	"./flat/32/Slovenia.png": "733d",
	"./flat/32/Solomon-Islands.png": "35f7",
	"./flat/32/Somalia.png": "faef",
	"./flat/32/Somaliland.png": "9a70",
	"./flat/32/South-Africa.png": "bfbf",
	"./flat/32/South-Georgia-and-the-South-Sandwich-Islands.png": "ee6e",
	"./flat/32/South-Korea.png": "34de",
	"./flat/32/South-Ossetia.png": "3ed3",
	"./flat/32/South-Sudan.png": "8b0b",
	"./flat/32/Spain.png": "3d4f",
	"./flat/32/Sri-Lanka.png": "a553",
	"./flat/32/Sudan.png": "affd",
	"./flat/32/Suriname.png": "09b8",
	"./flat/32/Swaziland.png": "1a37",
	"./flat/32/Sweden.png": "1e6a",
	"./flat/32/Switzerland.png": "54ff",
	"./flat/32/Syria.png": "4120",
	"./flat/32/Taiwan.png": "6308",
	"./flat/32/Tajikistan.png": "27de",
	"./flat/32/Tanzania.png": "9f48",
	"./flat/32/Thailand.png": "b089",
	"./flat/32/Togo.png": "d3f1",
	"./flat/32/Tokelau.png": "d124",
	"./flat/32/Tonga.png": "6f53",
	"./flat/32/Trinidad-and-Tobago.png": "1c39",
	"./flat/32/Tunisia.png": "1b5a",
	"./flat/32/Turkey.png": "a969",
	"./flat/32/Turkmenistan.png": "1f6b",
	"./flat/32/Turks-and-Caicos-Islands.png": "a1b2",
	"./flat/32/Tuvalu.png": "b1bc",
	"./flat/32/US-Virgin-Islands.png": "4e48",
	"./flat/32/Uganda.png": "794f",
	"./flat/32/Ukraine.png": "adcc",
	"./flat/32/United-Arab-Emirates.png": "6398",
	"./flat/32/United-Kingdom.png": "8564",
	"./flat/32/United-Nations.png": "f640",
	"./flat/32/United-States.png": "1dd8",
	"./flat/32/Unknown.png": "34ad",
	"./flat/32/Uruguay.png": "81fb",
	"./flat/32/Uzbekistan.png": "56dbe",
	"./flat/32/Vanuatu.png": "f34f",
	"./flat/32/Vatican-City.png": "f256",
	"./flat/32/Venezuela.png": "9e6aa",
	"./flat/32/Vietnam.png": "4b9f",
	"./flat/32/Wales.png": "a4ab",
	"./flat/32/Wallis-And-Futuna.png": "a37c",
	"./flat/32/Western-Sahara.png": "c0c4",
	"./flat/32/Yemen.png": "aeff",
	"./flat/32/Zambia.png": "b033",
	"./flat/32/Zimbabwe.png": "2f58",
	"./flat/48/Abkhazia.png": "115a",
	"./flat/48/Afghanistan.png": "6312",
	"./flat/48/Aland.png": "7e7f",
	"./flat/48/Albania.png": "ecab",
	"./flat/48/Algeria.png": "3a83",
	"./flat/48/American-Samoa.png": "20da",
	"./flat/48/Andorra.png": "4640",
	"./flat/48/Angola.png": "f4b8",
	"./flat/48/Anguilla.png": "2534",
	"./flat/48/Antarctica.png": "54c4",
	"./flat/48/Antigua-and-Barbuda.png": "0581",
	"./flat/48/Argentina.png": "e494",
	"./flat/48/Armenia.png": "b350",
	"./flat/48/Aruba.png": "f060",
	"./flat/48/Australia.png": "105c",
	"./flat/48/Austria.png": "83f4",
	"./flat/48/Azerbaijan.png": "4741",
	"./flat/48/Bahamas.png": "3de9",
	"./flat/48/Bahrain.png": "c303",
	"./flat/48/Bangladesh.png": "7fba",
	"./flat/48/Barbados.png": "0910",
	"./flat/48/Basque-Country.png": "08cc6",
	"./flat/48/Belarus.png": "bb50",
	"./flat/48/Belgium.png": "be9d",
	"./flat/48/Belize.png": "574d",
	"./flat/48/Benin.png": "2b69",
	"./flat/48/Bermuda.png": "a7f4a",
	"./flat/48/Bhutan.png": "0d05",
	"./flat/48/Bolivia.png": "a7de",
	"./flat/48/Bosnia-and-Herzegovina.png": "767a",
	"./flat/48/Botswana.png": "3f2b",
	"./flat/48/Brazil.png": "8295",
	"./flat/48/British-Antarctic-Territory.png": "5f7e",
	"./flat/48/British-Virgin-Islands.png": "8400",
	"./flat/48/Brunei.png": "3891",
	"./flat/48/Bulgaria.png": "25c3",
	"./flat/48/Burkina-Faso.png": "5136",
	"./flat/48/Burundi.png": "071a",
	"./flat/48/Cambodia.png": "caf8",
	"./flat/48/Cameroon.png": "7f32",
	"./flat/48/Canada.png": "b5d8",
	"./flat/48/Canary-Islands.png": "f063",
	"./flat/48/Cape-Verde.png": "55ec",
	"./flat/48/Cayman-Islands.png": "3ea1",
	"./flat/48/Central-African-Republic.png": "6e74",
	"./flat/48/Chad.png": "1aee",
	"./flat/48/Chile.png": "0e96",
	"./flat/48/China.png": "822e",
	"./flat/48/Christmas-Island.png": "8f03",
	"./flat/48/Cocos-Keeling-Islands.png": "ab75",
	"./flat/48/Colombia.png": "ccf6",
	"./flat/48/Commonwealth.png": "e20b",
	"./flat/48/Comoros.png": "a2f3",
	"./flat/48/Cook-Islands.png": "db96",
	"./flat/48/Costa-Rica.png": "4bd0",
	"./flat/48/Cote-dIvoire.png": "1d59",
	"./flat/48/Croatia.png": "d7fa",
	"./flat/48/Cuba.png": "5b7f",
	"./flat/48/Curacao.png": "78b2",
	"./flat/48/Cyprus.png": "0665",
	"./flat/48/Czech-Republic.png": "2365",
	"./flat/48/Democratic-Republic-of-the-Congo.png": "7c83",
	"./flat/48/Denmark.png": "9fef",
	"./flat/48/Djibouti.png": "f070",
	"./flat/48/Dominica.png": "f0c3",
	"./flat/48/Dominican-Republic.png": "83e0",
	"./flat/48/East-Timor.png": "27bb",
	"./flat/48/Ecuador.png": "02e5",
	"./flat/48/Egypt.png": "74e0",
	"./flat/48/El-Salvador.png": "7774",
	"./flat/48/England.png": "8d50",
	"./flat/48/Equatorial-Guinea.png": "ce49",
	"./flat/48/Eritrea.png": "8476",
	"./flat/48/Estonia.png": "e41c",
	"./flat/48/Ethiopia.png": "907e",
	"./flat/48/European-Union.png": "03da",
	"./flat/48/Falkland-Islands.png": "3020",
	"./flat/48/Faroes.png": "efc7",
	"./flat/48/Fiji.png": "1a96",
	"./flat/48/Finland.png": "3545",
	"./flat/48/France.png": "9393",
	"./flat/48/French-Polynesia.png": "c3454",
	"./flat/48/French-Southern-Territories.png": "04b5",
	"./flat/48/Gabon.png": "3805",
	"./flat/48/Gambia.png": "e057",
	"./flat/48/Georgia.png": "842e",
	"./flat/48/Germany.png": "a059",
	"./flat/48/Ghana.png": "0d9d",
	"./flat/48/Gibraltar.png": "c2b2",
	"./flat/48/GoSquared.png": "d746",
	"./flat/48/Greece.png": "c30f",
	"./flat/48/Greenland.png": "f338",
	"./flat/48/Grenada.png": "78980",
	"./flat/48/Guam.png": "3eec",
	"./flat/48/Guatemala.png": "54fa",
	"./flat/48/Guernsey.png": "63ad",
	"./flat/48/Guinea-Bissau.png": "da27",
	"./flat/48/Guinea.png": "1a0e",
	"./flat/48/Guyana.png": "baf4",
	"./flat/48/Haiti.png": "40a5",
	"./flat/48/Honduras.png": "447e",
	"./flat/48/Hong-Kong.png": "ecf5",
	"./flat/48/Hungary.png": "a0dd",
	"./flat/48/Iceland.png": "c19e",
	"./flat/48/India.png": "9fb0",
	"./flat/48/Indonesia.png": "82f4",
	"./flat/48/Iran.png": "faf6",
	"./flat/48/Iraq.png": "ea6c",
	"./flat/48/Ireland.png": "d325",
	"./flat/48/Isle-of-Man.png": "ce0a",
	"./flat/48/Israel.png": "7616",
	"./flat/48/Italy.png": "73c4",
	"./flat/48/Jamaica.png": "294b",
	"./flat/48/Japan.png": "6bb3",
	"./flat/48/Jersey.png": "cb00",
	"./flat/48/Jordan.png": "96c5",
	"./flat/48/Kazakhstan.png": "47d9",
	"./flat/48/Kenya.png": "d5e8",
	"./flat/48/Kiribati.png": "545d",
	"./flat/48/Kosovo.png": "f4c2",
	"./flat/48/Kuwait.png": "5f69",
	"./flat/48/Kyrgyzstan.png": "32e03",
	"./flat/48/Laos.png": "3b1b",
	"./flat/48/Latvia.png": "dbd7",
	"./flat/48/Lebanon.png": "caf9",
	"./flat/48/Lesotho.png": "b5b0",
	"./flat/48/Liberia.png": "296e",
	"./flat/48/Libya.png": "c5d4",
	"./flat/48/Liechtenstein.png": "cf1c",
	"./flat/48/Lithuania.png": "e82f",
	"./flat/48/Luxembourg.png": "04ea",
	"./flat/48/Macau.png": "889a",
	"./flat/48/Macedonia.png": "3f8c",
	"./flat/48/Madagascar.png": "8828",
	"./flat/48/Malawi.png": "0fe9",
	"./flat/48/Malaysia.png": "1329",
	"./flat/48/Maldives.png": "79ac",
	"./flat/48/Mali.png": "fc4c",
	"./flat/48/Malta.png": "bc32",
	"./flat/48/Mars.png": "94ed",
	"./flat/48/Marshall-Islands.png": "7ef5",
	"./flat/48/Martinique.png": "a781",
	"./flat/48/Mauritania.png": "28a4",
	"./flat/48/Mauritius.png": "aed7",
	"./flat/48/Mayotte.png": "e83c",
	"./flat/48/Mexico.png": "1b8a",
	"./flat/48/Micronesia.png": "0bea",
	"./flat/48/Moldova.png": "4a8e",
	"./flat/48/Monaco.png": "101f",
	"./flat/48/Mongolia.png": "ccab",
	"./flat/48/Montenegro.png": "be82",
	"./flat/48/Montserrat.png": "23c68",
	"./flat/48/Morocco.png": "2cda",
	"./flat/48/Mozambique.png": "3f67",
	"./flat/48/Myanmar.png": "cf3b",
	"./flat/48/NATO.png": "693a",
	"./flat/48/Nagorno-Karabakh.png": "ef5a",
	"./flat/48/Namibia.png": "ac94",
	"./flat/48/Nauru.png": "62a5",
	"./flat/48/Nepal.png": "73c1",
	"./flat/48/Netherlands-Antilles.png": "58dc",
	"./flat/48/Netherlands.png": "b3d7",
	"./flat/48/New-Caledonia.png": "79fe",
	"./flat/48/New-Zealand.png": "27b4",
	"./flat/48/Nicaragua.png": "3c3d",
	"./flat/48/Niger.png": "56dd",
	"./flat/48/Nigeria.png": "889c",
	"./flat/48/Niue.png": "e6e2",
	"./flat/48/Norfolk-Island.png": "f363",
	"./flat/48/North-Korea.png": "e531",
	"./flat/48/Northern-Cyprus.png": "ea46",
	"./flat/48/Northern-Mariana-Islands.png": "7b0d",
	"./flat/48/Norway.png": "2218",
	"./flat/48/Olympics.png": "70ce",
	"./flat/48/Oman.png": "3e2d",
	"./flat/48/Pakistan.png": "de01",
	"./flat/48/Palau.png": "417e",
	"./flat/48/Palestine.png": "7e32",
	"./flat/48/Panama.png": "91b9",
	"./flat/48/Papua-New-Guinea.png": "bc60",
	"./flat/48/Paraguay.png": "1f08",
	"./flat/48/Peru.png": "3b4c",
	"./flat/48/Philippines.png": "6cb6",
	"./flat/48/Pitcairn-Islands.png": "76e4",
	"./flat/48/Poland.png": "437b7",
	"./flat/48/Portugal.png": "3adb",
	"./flat/48/Puerto-Rico.png": "3ac4",
	"./flat/48/Qatar.png": "aac1",
	"./flat/48/Red-Cross.png": "23a0",
	"./flat/48/Republic-of-the-Congo.png": "133b",
	"./flat/48/Romania.png": "0e72",
	"./flat/48/Russia.png": "f554",
	"./flat/48/Rwanda.png": "eb8a",
	"./flat/48/Saint-Barthelemy.png": "4ea9",
	"./flat/48/Saint-Helena.png": "b808",
	"./flat/48/Saint-Kitts-and-Nevis.png": "8c8b",
	"./flat/48/Saint-Lucia.png": "891c",
	"./flat/48/Saint-Martin.png": "c6652",
	"./flat/48/Saint-Vincent-and-the-Grenadines.png": "e242",
	"./flat/48/Samoa.png": "eb98",
	"./flat/48/San-Marino.png": "0ae2",
	"./flat/48/Sao-Tome-and-Principe.png": "fabe",
	"./flat/48/Saudi-Arabia.png": "c00d",
	"./flat/48/Scotland.png": "0bb2",
	"./flat/48/Senegal.png": "cf83",
	"./flat/48/Serbia.png": "c535",
	"./flat/48/Seychelles.png": "dbc2",
	"./flat/48/Sierra-Leone.png": "1279",
	"./flat/48/Singapore.png": "3a107",
	"./flat/48/Slovakia.png": "1ee5",
	"./flat/48/Slovenia.png": "e042",
	"./flat/48/Solomon-Islands.png": "f0fb",
	"./flat/48/Somalia.png": "8b75",
	"./flat/48/Somaliland.png": "06b9",
	"./flat/48/South-Africa.png": "9ac4",
	"./flat/48/South-Georgia-and-the-South-Sandwich-Islands.png": "d445",
	"./flat/48/South-Korea.png": "cae72",
	"./flat/48/South-Ossetia.png": "d546",
	"./flat/48/South-Sudan.png": "e037",
	"./flat/48/Spain.png": "9d0c",
	"./flat/48/Sri-Lanka.png": "42ed",
	"./flat/48/Sudan.png": "d7d8",
	"./flat/48/Suriname.png": "1cc2",
	"./flat/48/Swaziland.png": "21cf",
	"./flat/48/Sweden.png": "4ef3",
	"./flat/48/Switzerland.png": "9923",
	"./flat/48/Syria.png": "f746",
	"./flat/48/Taiwan.png": "55ca",
	"./flat/48/Tajikistan.png": "e3fb",
	"./flat/48/Tanzania.png": "389a",
	"./flat/48/Thailand.png": "461a",
	"./flat/48/Togo.png": "84b0",
	"./flat/48/Tokelau.png": "1a51",
	"./flat/48/Tonga.png": "1a0c",
	"./flat/48/Trinidad-and-Tobago.png": "8681",
	"./flat/48/Tunisia.png": "2414",
	"./flat/48/Turkey.png": "fd51",
	"./flat/48/Turkmenistan.png": "9040",
	"./flat/48/Turks-and-Caicos-Islands.png": "c0b8",
	"./flat/48/Tuvalu.png": "2f4d",
	"./flat/48/US-Virgin-Islands.png": "13a3",
	"./flat/48/Uganda.png": "a161",
	"./flat/48/Ukraine.png": "2c18",
	"./flat/48/United-Arab-Emirates.png": "b76e",
	"./flat/48/United-Kingdom.png": "d683",
	"./flat/48/United-Nations.png": "2411",
	"./flat/48/United-States.png": "b338",
	"./flat/48/Unknown.png": "4b8c",
	"./flat/48/Uruguay.png": "33c9",
	"./flat/48/Uzbekistan.png": "a03c",
	"./flat/48/Vanuatu.png": "1c6b",
	"./flat/48/Vatican-City.png": "5c45",
	"./flat/48/Venezuela.png": "3ee4",
	"./flat/48/Vietnam.png": "241f",
	"./flat/48/Wales.png": "eada",
	"./flat/48/Wallis-And-Futuna.png": "4d9a",
	"./flat/48/Western-Sahara.png": "1ea3",
	"./flat/48/Yemen.png": "7e51",
	"./flat/48/Zambia.png": "4932",
	"./flat/48/Zimbabwe.png": "75bc",
	"./flat/64/Abkhazia.png": "efca9",
	"./flat/64/Afghanistan.png": "25f7",
	"./flat/64/Aland.png": "66fe",
	"./flat/64/Albania.png": "6226",
	"./flat/64/Algeria.png": "4239",
	"./flat/64/American-Samoa.png": "48a09",
	"./flat/64/Andorra.png": "19a9",
	"./flat/64/Angola.png": "0807",
	"./flat/64/Anguilla.png": "1fec",
	"./flat/64/Antarctica.png": "75c2",
	"./flat/64/Antigua-and-Barbuda.png": "dcfa",
	"./flat/64/Argentina.png": "5503",
	"./flat/64/Armenia.png": "462d",
	"./flat/64/Aruba.png": "ce32",
	"./flat/64/Australia.png": "497e",
	"./flat/64/Austria.png": "736b",
	"./flat/64/Azerbaijan.png": "060b",
	"./flat/64/Bahamas.png": "3b3c",
	"./flat/64/Bahrain.png": "5aa1",
	"./flat/64/Bangladesh.png": "7740",
	"./flat/64/Barbados.png": "a8c6",
	"./flat/64/Basque-Country.png": "a573",
	"./flat/64/Belarus.png": "50f6",
	"./flat/64/Belgium.png": "6fc8",
	"./flat/64/Belize.png": "ea83",
	"./flat/64/Benin.png": "e95b",
	"./flat/64/Bermuda.png": "f850",
	"./flat/64/Bhutan.png": "ee56",
	"./flat/64/Bolivia.png": "7c3c",
	"./flat/64/Bosnia-and-Herzegovina.png": "5d4c",
	"./flat/64/Botswana.png": "5400",
	"./flat/64/Brazil.png": "1841",
	"./flat/64/British-Antarctic-Territory.png": "b56e",
	"./flat/64/British-Virgin-Islands.png": "baa6",
	"./flat/64/Brunei.png": "ffe8",
	"./flat/64/Bulgaria.png": "dd07",
	"./flat/64/Burkina-Faso.png": "cf83a",
	"./flat/64/Burundi.png": "8832",
	"./flat/64/Cambodia.png": "732f",
	"./flat/64/Cameroon.png": "2ce3",
	"./flat/64/Canada.png": "bde7",
	"./flat/64/Canary-Islands.png": "07ef",
	"./flat/64/Cape-Verde.png": "11f0",
	"./flat/64/Cayman-Islands.png": "467a",
	"./flat/64/Central-African-Republic.png": "149d",
	"./flat/64/Chad.png": "4ab5",
	"./flat/64/Chile.png": "5679",
	"./flat/64/China.png": "1e3ce",
	"./flat/64/Christmas-Island.png": "cfb2",
	"./flat/64/Cocos-Keeling-Islands.png": "1d90",
	"./flat/64/Colombia.png": "a671",
	"./flat/64/Commonwealth.png": "ff9b",
	"./flat/64/Comoros.png": "bbf9",
	"./flat/64/Cook-Islands.png": "ccb4",
	"./flat/64/Costa-Rica.png": "2539",
	"./flat/64/Cote-dIvoire.png": "ffbf",
	"./flat/64/Croatia.png": "73cf",
	"./flat/64/Cuba.png": "28d3",
	"./flat/64/Curacao.png": "4b4f",
	"./flat/64/Cyprus.png": "1cc3",
	"./flat/64/Czech-Republic.png": "ee15",
	"./flat/64/Democratic-Republic-of-the-Congo.png": "e4a2",
	"./flat/64/Denmark.png": "e7ec",
	"./flat/64/Djibouti.png": "2fc0",
	"./flat/64/Dominica.png": "95b4",
	"./flat/64/Dominican-Republic.png": "0c2d",
	"./flat/64/East-Timor.png": "e78b",
	"./flat/64/Ecuador.png": "e81c",
	"./flat/64/Egypt.png": "dc85",
	"./flat/64/El-Salvador.png": "4408",
	"./flat/64/England.png": "fd3f",
	"./flat/64/Equatorial-Guinea.png": "c2fb",
	"./flat/64/Eritrea.png": "fd15",
	"./flat/64/Estonia.png": "dffd",
	"./flat/64/Ethiopia.png": "3d57",
	"./flat/64/European-Union.png": "90db",
	"./flat/64/Falkland-Islands.png": "5ea9",
	"./flat/64/Faroes.png": "9aa9",
	"./flat/64/Fiji.png": "833b",
	"./flat/64/Finland.png": "8a2a",
	"./flat/64/France.png": "55db",
	"./flat/64/French-Polynesia.png": "9748",
	"./flat/64/French-Southern-Territories.png": "5881",
	"./flat/64/Gabon.png": "fb1f",
	"./flat/64/Gambia.png": "0b72",
	"./flat/64/Georgia.png": "4bd5",
	"./flat/64/Germany.png": "ded7",
	"./flat/64/Ghana.png": "7c6c",
	"./flat/64/Gibraltar.png": "88bf",
	"./flat/64/GoSquared.png": "13c9",
	"./flat/64/Greece.png": "45df",
	"./flat/64/Greenland.png": "e947",
	"./flat/64/Grenada.png": "55b0",
	"./flat/64/Guam.png": "b050",
	"./flat/64/Guatemala.png": "bc24",
	"./flat/64/Guernsey.png": "cf4c",
	"./flat/64/Guinea-Bissau.png": "6031",
	"./flat/64/Guinea.png": "d8c9",
	"./flat/64/Guyana.png": "ce99",
	"./flat/64/Haiti.png": "4c09",
	"./flat/64/Honduras.png": "2ecf",
	"./flat/64/Hong-Kong.png": "d644",
	"./flat/64/Hungary.png": "5663",
	"./flat/64/Iceland.png": "e1d5",
	"./flat/64/India.png": "49ae",
	"./flat/64/Indonesia.png": "3f37",
	"./flat/64/Iran.png": "1b05",
	"./flat/64/Iraq.png": "8728",
	"./flat/64/Ireland.png": "409c",
	"./flat/64/Isle-of-Man.png": "122c",
	"./flat/64/Israel.png": "1f7c",
	"./flat/64/Italy.png": "e9c2",
	"./flat/64/Jamaica.png": "160f",
	"./flat/64/Japan.png": "f89d",
	"./flat/64/Jersey.png": "db42",
	"./flat/64/Jordan.png": "e1e0",
	"./flat/64/Kazakhstan.png": "a4bc",
	"./flat/64/Kenya.png": "f450",
	"./flat/64/Kiribati.png": "4ff9",
	"./flat/64/Kosovo.png": "373a",
	"./flat/64/Kuwait.png": "c0ba",
	"./flat/64/Kyrgyzstan.png": "9c26",
	"./flat/64/Laos.png": "4dbb",
	"./flat/64/Latvia.png": "4425",
	"./flat/64/Lebanon.png": "70df",
	"./flat/64/Lesotho.png": "2e62",
	"./flat/64/Liberia.png": "8a4d",
	"./flat/64/Libya.png": "2417",
	"./flat/64/Liechtenstein.png": "7b11",
	"./flat/64/Lithuania.png": "7a8a",
	"./flat/64/Luxembourg.png": "98c5",
	"./flat/64/Macau.png": "80ab",
	"./flat/64/Macedonia.png": "cd07",
	"./flat/64/Madagascar.png": "6ad4",
	"./flat/64/Malawi.png": "53d9",
	"./flat/64/Malaysia.png": "8aac",
	"./flat/64/Maldives.png": "1ae2",
	"./flat/64/Mali.png": "6c32",
	"./flat/64/Malta.png": "20eb",
	"./flat/64/Mars.png": "e578",
	"./flat/64/Marshall-Islands.png": "61ed",
	"./flat/64/Martinique.png": "c046",
	"./flat/64/Mauritania.png": "4f8a",
	"./flat/64/Mauritius.png": "cd97",
	"./flat/64/Mayotte.png": "b9b2",
	"./flat/64/Mexico.png": "2a23",
	"./flat/64/Micronesia.png": "9122",
	"./flat/64/Moldova.png": "7c6e",
	"./flat/64/Monaco.png": "cea1",
	"./flat/64/Mongolia.png": "f170",
	"./flat/64/Montenegro.png": "d691",
	"./flat/64/Montserrat.png": "4a1d",
	"./flat/64/Morocco.png": "3b9a",
	"./flat/64/Mozambique.png": "cd10",
	"./flat/64/Myanmar.png": "15af",
	"./flat/64/NATO.png": "d888",
	"./flat/64/Nagorno-Karabakh.png": "1383",
	"./flat/64/Namibia.png": "49f9",
	"./flat/64/Nauru.png": "2a2c",
	"./flat/64/Nepal.png": "026a",
	"./flat/64/Netherlands-Antilles.png": "1580",
	"./flat/64/Netherlands.png": "c0ac",
	"./flat/64/New-Caledonia.png": "3f2e",
	"./flat/64/New-Zealand.png": "d781",
	"./flat/64/Nicaragua.png": "ca42",
	"./flat/64/Niger.png": "fab6",
	"./flat/64/Nigeria.png": "484c",
	"./flat/64/Niue.png": "82d9",
	"./flat/64/Norfolk-Island.png": "d593",
	"./flat/64/North-Korea.png": "0e54",
	"./flat/64/Northern-Cyprus.png": "34bc",
	"./flat/64/Northern-Mariana-Islands.png": "743b",
	"./flat/64/Norway.png": "6cfc",
	"./flat/64/Olympics.png": "b5a7c",
	"./flat/64/Oman.png": "5690",
	"./flat/64/Pakistan.png": "ce13",
	"./flat/64/Palau.png": "fa17",
	"./flat/64/Palestine.png": "0ec3",
	"./flat/64/Panama.png": "16e7",
	"./flat/64/Papua-New-Guinea.png": "e3f2",
	"./flat/64/Paraguay.png": "6fbc",
	"./flat/64/Peru.png": "9ea8",
	"./flat/64/Philippines.png": "87df",
	"./flat/64/Pitcairn-Islands.png": "964e",
	"./flat/64/Poland.png": "4d74",
	"./flat/64/Portugal.png": "b932",
	"./flat/64/Puerto-Rico.png": "adc3",
	"./flat/64/Qatar.png": "6771",
	"./flat/64/Red-Cross.png": "0ed7",
	"./flat/64/Republic-of-the-Congo.png": "da83",
	"./flat/64/Romania.png": "ef35",
	"./flat/64/Russia.png": "a4b3",
	"./flat/64/Rwanda.png": "8ad6",
	"./flat/64/Saint-Barthelemy.png": "4447",
	"./flat/64/Saint-Helena.png": "c515",
	"./flat/64/Saint-Kitts-and-Nevis.png": "e0f1",
	"./flat/64/Saint-Lucia.png": "94a3",
	"./flat/64/Saint-Martin.png": "d67c",
	"./flat/64/Saint-Vincent-and-the-Grenadines.png": "1bf5",
	"./flat/64/Samoa.png": "80b9",
	"./flat/64/San-Marino.png": "ef93",
	"./flat/64/Sao-Tome-and-Principe.png": "932d",
	"./flat/64/Saudi-Arabia.png": "546a",
	"./flat/64/Scotland.png": "7ef9",
	"./flat/64/Senegal.png": "f71c",
	"./flat/64/Serbia.png": "4ef6",
	"./flat/64/Seychelles.png": "f2c9",
	"./flat/64/Sierra-Leone.png": "fff2",
	"./flat/64/Singapore.png": "6836",
	"./flat/64/Slovakia.png": "414e",
	"./flat/64/Slovenia.png": "9746",
	"./flat/64/Solomon-Islands.png": "9323",
	"./flat/64/Somalia.png": "f866",
	"./flat/64/Somaliland.png": "f263",
	"./flat/64/South-Africa.png": "77ff",
	"./flat/64/South-Georgia-and-the-South-Sandwich-Islands.png": "b619",
	"./flat/64/South-Korea.png": "d817",
	"./flat/64/South-Ossetia.png": "8cfc",
	"./flat/64/South-Sudan.png": "e8d1",
	"./flat/64/Spain.png": "cfd6",
	"./flat/64/Sri-Lanka.png": "a956",
	"./flat/64/Sudan.png": "195a",
	"./flat/64/Suriname.png": "244d",
	"./flat/64/Swaziland.png": "39bd",
	"./flat/64/Sweden.png": "32df",
	"./flat/64/Switzerland.png": "85e1",
	"./flat/64/Syria.png": "2f11",
	"./flat/64/Taiwan.png": "86af",
	"./flat/64/Tajikistan.png": "0c08",
	"./flat/64/Tanzania.png": "5d4a",
	"./flat/64/Thailand.png": "f534",
	"./flat/64/Togo.png": "df03",
	"./flat/64/Tokelau.png": "5e87",
	"./flat/64/Tonga.png": "be54",
	"./flat/64/Trinidad-and-Tobago.png": "ca4d",
	"./flat/64/Tunisia.png": "94b9",
	"./flat/64/Turkey.png": "befc",
	"./flat/64/Turkmenistan.png": "f94c",
	"./flat/64/Turks-and-Caicos-Islands.png": "b78e",
	"./flat/64/Tuvalu.png": "d49f",
	"./flat/64/US-Virgin-Islands.png": "beaf",
	"./flat/64/Uganda.png": "abaf",
	"./flat/64/Ukraine.png": "562c",
	"./flat/64/United-Arab-Emirates.png": "f864",
	"./flat/64/United-Kingdom.png": "6888",
	"./flat/64/United-Nations.png": "dbf5",
	"./flat/64/United-States.png": "a287",
	"./flat/64/Unknown.png": "87c7",
	"./flat/64/Uruguay.png": "f786",
	"./flat/64/Uzbekistan.png": "6bed",
	"./flat/64/Vanuatu.png": "36df",
	"./flat/64/Vatican-City.png": "4d67",
	"./flat/64/Venezuela.png": "4769",
	"./flat/64/Vietnam.png": "b485",
	"./flat/64/Wales.png": "10df",
	"./flat/64/Wallis-And-Futuna.png": "2c11",
	"./flat/64/Western-Sahara.png": "56f2",
	"./flat/64/Yemen.png": "be3d",
	"./flat/64/Zambia.png": "b2d5",
	"./flat/64/Zimbabwe.png": "8de6",
	"./shiny/16/Abkhazia.png": "8ca0",
	"./shiny/16/Afghanistan.png": "928f",
	"./shiny/16/Aland.png": "992d",
	"./shiny/16/Albania.png": "8c01",
	"./shiny/16/Algeria.png": "726d",
	"./shiny/16/American-Samoa.png": "7ec5",
	"./shiny/16/Andorra.png": "ec55",
	"./shiny/16/Angola.png": "4fce",
	"./shiny/16/Anguilla.png": "4a93",
	"./shiny/16/Antarctica.png": "c877",
	"./shiny/16/Antigua-and-Barbuda.png": "3830",
	"./shiny/16/Argentina.png": "c329",
	"./shiny/16/Armenia.png": "d265",
	"./shiny/16/Aruba.png": "8a37",
	"./shiny/16/Australia.png": "8eb6",
	"./shiny/16/Austria.png": "27be",
	"./shiny/16/Azerbaijan.png": "0fb9",
	"./shiny/16/Bahamas.png": "bd9a",
	"./shiny/16/Bahrain.png": "7a5b",
	"./shiny/16/Bangladesh.png": "942d",
	"./shiny/16/Barbados.png": "7913",
	"./shiny/16/Basque-Country.png": "3f02",
	"./shiny/16/Belarus.png": "901e",
	"./shiny/16/Belgium.png": "dc27",
	"./shiny/16/Belize.png": "8ce7",
	"./shiny/16/Benin.png": "2215",
	"./shiny/16/Bermuda.png": "d5cc",
	"./shiny/16/Bhutan.png": "159ae",
	"./shiny/16/Bolivia.png": "22a9",
	"./shiny/16/Bosnia-and-Herzegovina.png": "e34b",
	"./shiny/16/Botswana.png": "b7f5",
	"./shiny/16/Brazil.png": "3a4b",
	"./shiny/16/British-Antarctic-Territory.png": "60d6",
	"./shiny/16/British-Virgin-Islands.png": "86ca",
	"./shiny/16/Brunei.png": "c000",
	"./shiny/16/Bulgaria.png": "5b03",
	"./shiny/16/Burkina-Faso.png": "1545",
	"./shiny/16/Burundi.png": "afec",
	"./shiny/16/Cambodia.png": "bda2",
	"./shiny/16/Cameroon.png": "560c",
	"./shiny/16/Canada.png": "345b",
	"./shiny/16/Canary-Islands.png": "c67b",
	"./shiny/16/Cape-Verde.png": "c5c3",
	"./shiny/16/Cayman-Islands.png": "4e2e",
	"./shiny/16/Central-African-Republic.png": "dafd",
	"./shiny/16/Chad.png": "16a3",
	"./shiny/16/Chile.png": "ce4c",
	"./shiny/16/China.png": "2d47",
	"./shiny/16/Christmas-Island.png": "5010",
	"./shiny/16/Cocos-Keeling-Islands.png": "9093a",
	"./shiny/16/Colombia.png": "42d3",
	"./shiny/16/Commonwealth.png": "7710",
	"./shiny/16/Comoros.png": "dbfd",
	"./shiny/16/Cook-Islands.png": "54d0",
	"./shiny/16/Costa-Rica.png": "714f",
	"./shiny/16/Cote-dIvoire.png": "9371",
	"./shiny/16/Croatia.png": "94ba",
	"./shiny/16/Cuba.png": "b13f",
	"./shiny/16/Curacao.png": "ba58",
	"./shiny/16/Cyprus.png": "30c44",
	"./shiny/16/Czech-Republic.png": "b3f9",
	"./shiny/16/Democratic-Republic-of-the-Congo.png": "c983",
	"./shiny/16/Denmark.png": "b06f",
	"./shiny/16/Djibouti.png": "d76a",
	"./shiny/16/Dominica.png": "32fa",
	"./shiny/16/Dominican-Republic.png": "815e",
	"./shiny/16/East-Timor.png": "3260",
	"./shiny/16/Ecuador.png": "194b",
	"./shiny/16/Egypt.png": "6787",
	"./shiny/16/El-Salvador.png": "25f5",
	"./shiny/16/England.png": "d3c5",
	"./shiny/16/Equatorial-Guinea.png": "f634",
	"./shiny/16/Eritrea.png": "9067",
	"./shiny/16/Estonia.png": "2aeb9",
	"./shiny/16/Ethiopia.png": "49f6",
	"./shiny/16/European-Union.png": "1e54",
	"./shiny/16/Falkland-Islands.png": "0369",
	"./shiny/16/Faroes.png": "37bc",
	"./shiny/16/Fiji.png": "a845",
	"./shiny/16/Finland.png": "bb03",
	"./shiny/16/France.png": "68b1",
	"./shiny/16/French-Polynesia.png": "ae5b",
	"./shiny/16/French-Southern-Territories.png": "8137",
	"./shiny/16/Gabon.png": "91d9",
	"./shiny/16/Gambia.png": "bd04",
	"./shiny/16/Georgia.png": "4c5c",
	"./shiny/16/Germany.png": "1fb6",
	"./shiny/16/Ghana.png": "504c",
	"./shiny/16/Gibraltar.png": "c58e",
	"./shiny/16/GoSquared.png": "37d0",
	"./shiny/16/Greece.png": "828e",
	"./shiny/16/Greenland.png": "84fd",
	"./shiny/16/Grenada.png": "2cf0",
	"./shiny/16/Guam.png": "daf2",
	"./shiny/16/Guatemala.png": "1282",
	"./shiny/16/Guernsey.png": "e23a",
	"./shiny/16/Guinea-Bissau.png": "eef2",
	"./shiny/16/Guinea.png": "cbe8",
	"./shiny/16/Guyana.png": "aad3",
	"./shiny/16/Haiti.png": "4c6a",
	"./shiny/16/Honduras.png": "2e23",
	"./shiny/16/Hong-Kong.png": "c571",
	"./shiny/16/Hungary.png": "607f",
	"./shiny/16/Iceland.png": "0290",
	"./shiny/16/India.png": "ab63",
	"./shiny/16/Indonesia.png": "f180",
	"./shiny/16/Iran.png": "a4543",
	"./shiny/16/Iraq.png": "52c7",
	"./shiny/16/Ireland.png": "49b2",
	"./shiny/16/Isle-of-Man.png": "4ce9",
	"./shiny/16/Israel.png": "5da1",
	"./shiny/16/Italy.png": "0db4",
	"./shiny/16/Jamaica.png": "78af",
	"./shiny/16/Japan.png": "d0a7",
	"./shiny/16/Jersey.png": "74c2",
	"./shiny/16/Jordan.png": "94fc",
	"./shiny/16/Kazakhstan.png": "017c",
	"./shiny/16/Kenya.png": "0722",
	"./shiny/16/Kiribati.png": "85fa",
	"./shiny/16/Kosovo.png": "2710",
	"./shiny/16/Kuwait.png": "0986",
	"./shiny/16/Kyrgyzstan.png": "d380",
	"./shiny/16/Laos.png": "cd8e",
	"./shiny/16/Latvia.png": "bcf7",
	"./shiny/16/Lebanon.png": "963e",
	"./shiny/16/Lesotho.png": "dfef",
	"./shiny/16/Liberia.png": "c21e",
	"./shiny/16/Libya.png": "d2c0",
	"./shiny/16/Liechtenstein.png": "0b52",
	"./shiny/16/Lithuania.png": "11d3f",
	"./shiny/16/Luxembourg.png": "23fc",
	"./shiny/16/Macau.png": "8c29",
	"./shiny/16/Macedonia.png": "75a3",
	"./shiny/16/Madagascar.png": "1aae",
	"./shiny/16/Malawi.png": "a78c",
	"./shiny/16/Malaysia.png": "4580",
	"./shiny/16/Maldives.png": "6309",
	"./shiny/16/Mali.png": "a999",
	"./shiny/16/Malta.png": "857e",
	"./shiny/16/Mars.png": "5a36",
	"./shiny/16/Marshall-Islands.png": "9043",
	"./shiny/16/Martinique.png": "13049",
	"./shiny/16/Mauritania.png": "ff81",
	"./shiny/16/Mauritius.png": "cea2",
	"./shiny/16/Mayotte.png": "937b",
	"./shiny/16/Mexico.png": "c9cb",
	"./shiny/16/Micronesia.png": "6de3",
	"./shiny/16/Moldova.png": "b1c7",
	"./shiny/16/Monaco.png": "c093",
	"./shiny/16/Mongolia.png": "8c6d",
	"./shiny/16/Montenegro.png": "7c21",
	"./shiny/16/Montserrat.png": "8a94",
	"./shiny/16/Morocco.png": "dc0e",
	"./shiny/16/Mozambique.png": "2f3a",
	"./shiny/16/Myanmar.png": "87676",
	"./shiny/16/NATO.png": "8c8d",
	"./shiny/16/Nagorno-Karabakh.png": "c0c7",
	"./shiny/16/Namibia.png": "92de",
	"./shiny/16/Nauru.png": "f729",
	"./shiny/16/Nepal.png": "f9ab",
	"./shiny/16/Netherlands-Antilles.png": "118e",
	"./shiny/16/Netherlands.png": "e089",
	"./shiny/16/New-Caledonia.png": "afac",
	"./shiny/16/New-Zealand.png": "cf5f",
	"./shiny/16/Nicaragua.png": "2ba2",
	"./shiny/16/Niger.png": "c3ec",
	"./shiny/16/Nigeria.png": "5f50",
	"./shiny/16/Niue.png": "78ee",
	"./shiny/16/Norfolk-Island.png": "e595",
	"./shiny/16/North-Korea.png": "6875",
	"./shiny/16/Northern-Cyprus.png": "452c",
	"./shiny/16/Northern-Mariana-Islands.png": "9bd8",
	"./shiny/16/Norway.png": "8a65",
	"./shiny/16/Olympics.png": "ed4c",
	"./shiny/16/Oman.png": "4800",
	"./shiny/16/Pakistan.png": "b876",
	"./shiny/16/Palau.png": "99c3",
	"./shiny/16/Palestine.png": "1107",
	"./shiny/16/Panama.png": "9d55",
	"./shiny/16/Papua-New-Guinea.png": "1fb6b",
	"./shiny/16/Paraguay.png": "3e5e",
	"./shiny/16/Peru.png": "413b",
	"./shiny/16/Philippines.png": "7469",
	"./shiny/16/Pitcairn-Islands.png": "83ea",
	"./shiny/16/Poland.png": "731c",
	"./shiny/16/Portugal.png": "954d",
	"./shiny/16/Puerto-Rico.png": "31db",
	"./shiny/16/Qatar.png": "22a8",
	"./shiny/16/Red-Cross.png": "b468",
	"./shiny/16/Republic-of-the-Congo.png": "c45c",
	"./shiny/16/Romania.png": "775f",
	"./shiny/16/Russia.png": "14d5",
	"./shiny/16/Rwanda.png": "4a36",
	"./shiny/16/Saint-Barthelemy.png": "9ca7",
	"./shiny/16/Saint-Helena.png": "8bb2",
	"./shiny/16/Saint-Kitts-and-Nevis.png": "9a5e",
	"./shiny/16/Saint-Lucia.png": "ea03",
	"./shiny/16/Saint-Martin.png": "feb0",
	"./shiny/16/Saint-Vincent-and-the-Grenadines.png": "335f",
	"./shiny/16/Samoa.png": "9402",
	"./shiny/16/San-Marino.png": "8098",
	"./shiny/16/Sao-Tome-and-Principe.png": "e24c",
	"./shiny/16/Saudi-Arabia.png": "bcc13",
	"./shiny/16/Scotland.png": "f264",
	"./shiny/16/Senegal.png": "a804",
	"./shiny/16/Serbia.png": "e986",
	"./shiny/16/Seychelles.png": "f141",
	"./shiny/16/Sierra-Leone.png": "28f0",
	"./shiny/16/Singapore.png": "ea3e",
	"./shiny/16/Slovakia.png": "0833",
	"./shiny/16/Slovenia.png": "d41e",
	"./shiny/16/Solomon-Islands.png": "f5db",
	"./shiny/16/Somalia.png": "cebc",
	"./shiny/16/Somaliland.png": "f892",
	"./shiny/16/South-Africa.png": "f491",
	"./shiny/16/South-Georgia-and-the-South-Sandwich-Islands.png": "5d10",
	"./shiny/16/South-Korea.png": "ec7d",
	"./shiny/16/South-Ossetia.png": "98db",
	"./shiny/16/South-Sudan.png": "f12a",
	"./shiny/16/Spain.png": "4e72",
	"./shiny/16/Sri-Lanka.png": "07c9",
	"./shiny/16/Sudan.png": "df2b",
	"./shiny/16/Suriname.png": "a16e",
	"./shiny/16/Swaziland.png": "3ede",
	"./shiny/16/Sweden.png": "619d",
	"./shiny/16/Switzerland.png": "6a4b",
	"./shiny/16/Syria.png": "2a62",
	"./shiny/16/Taiwan.png": "a073",
	"./shiny/16/Tajikistan.png": "0e93",
	"./shiny/16/Tanzania.png": "1dd0",
	"./shiny/16/Thailand.png": "daf5",
	"./shiny/16/Togo.png": "e600",
	"./shiny/16/Tokelau.png": "b2366",
	"./shiny/16/Tonga.png": "e78c",
	"./shiny/16/Trinidad-and-Tobago.png": "edcd",
	"./shiny/16/Tunisia.png": "027d",
	"./shiny/16/Turkey.png": "7b9a",
	"./shiny/16/Turkmenistan.png": "c973",
	"./shiny/16/Turks-and-Caicos-Islands.png": "e6cc",
	"./shiny/16/Tuvalu.png": "fef6",
	"./shiny/16/US-Virgin-Islands.png": "9baf",
	"./shiny/16/Uganda.png": "f51e",
	"./shiny/16/Ukraine.png": "8269",
	"./shiny/16/United-Arab-Emirates.png": "8a6b",
	"./shiny/16/United-Kingdom.png": "b273",
	"./shiny/16/United-Nations.png": "7bc1",
	"./shiny/16/United-States.png": "702d",
	"./shiny/16/Unknown.png": "0031",
	"./shiny/16/Uruguay.png": "e360",
	"./shiny/16/Uzbekistan.png": "f735",
	"./shiny/16/Vanuatu.png": "54e8",
	"./shiny/16/Vatican-City.png": "b74e",
	"./shiny/16/Venezuela.png": "67d3",
	"./shiny/16/Vietnam.png": "2841",
	"./shiny/16/Wales.png": "c889",
	"./shiny/16/Wallis-And-Futuna.png": "0b01",
	"./shiny/16/Western-Sahara.png": "391c",
	"./shiny/16/Yemen.png": "605e",
	"./shiny/16/Zambia.png": "90a4",
	"./shiny/16/Zimbabwe.png": "c207",
	"./shiny/24/Abkhazia.png": "18dd",
	"./shiny/24/Afghanistan.png": "e302",
	"./shiny/24/Aland.png": "cf46",
	"./shiny/24/Albania.png": "35e5",
	"./shiny/24/Algeria.png": "10e8",
	"./shiny/24/American-Samoa.png": "0736",
	"./shiny/24/Andorra.png": "258e",
	"./shiny/24/Angola.png": "3ada",
	"./shiny/24/Anguilla.png": "f71a",
	"./shiny/24/Antarctica.png": "88a9",
	"./shiny/24/Antigua-and-Barbuda.png": "46a4",
	"./shiny/24/Argentina.png": "9bca",
	"./shiny/24/Armenia.png": "2c8f",
	"./shiny/24/Aruba.png": "2d007",
	"./shiny/24/Australia.png": "7c84",
	"./shiny/24/Austria.png": "c3fb",
	"./shiny/24/Azerbaijan.png": "1fe1",
	"./shiny/24/Bahamas.png": "390c",
	"./shiny/24/Bahrain.png": "b884",
	"./shiny/24/Bangladesh.png": "d411",
	"./shiny/24/Barbados.png": "d78c",
	"./shiny/24/Basque-Country.png": "20af",
	"./shiny/24/Belarus.png": "5bac",
	"./shiny/24/Belgium.png": "64a0",
	"./shiny/24/Belize.png": "f32b",
	"./shiny/24/Benin.png": "85ed",
	"./shiny/24/Bermuda.png": "b474",
	"./shiny/24/Bhutan.png": "045b",
	"./shiny/24/Bolivia.png": "ff8e",
	"./shiny/24/Bosnia-and-Herzegovina.png": "70f6",
	"./shiny/24/Botswana.png": "365a",
	"./shiny/24/Brazil.png": "6471",
	"./shiny/24/British-Antarctic-Territory.png": "45d4",
	"./shiny/24/British-Virgin-Islands.png": "c88c",
	"./shiny/24/Brunei.png": "1c51",
	"./shiny/24/Bulgaria.png": "fd72",
	"./shiny/24/Burkina-Faso.png": "1885",
	"./shiny/24/Burundi.png": "be4d",
	"./shiny/24/Cambodia.png": "812b",
	"./shiny/24/Cameroon.png": "30e1",
	"./shiny/24/Canada.png": "01b4",
	"./shiny/24/Canary-Islands.png": "50b5",
	"./shiny/24/Cape-Verde.png": "b317",
	"./shiny/24/Cayman-Islands.png": "4fa9",
	"./shiny/24/Central-African-Republic.png": "dd2a",
	"./shiny/24/Chad.png": "1ee5d",
	"./shiny/24/Chile.png": "4679",
	"./shiny/24/China.png": "d545",
	"./shiny/24/Christmas-Island.png": "2ad6",
	"./shiny/24/Cocos-Keeling-Islands.png": "4342",
	"./shiny/24/Colombia.png": "1393",
	"./shiny/24/Commonwealth.png": "d1a4",
	"./shiny/24/Comoros.png": "9421",
	"./shiny/24/Cook-Islands.png": "e499",
	"./shiny/24/Costa-Rica.png": "7dd5",
	"./shiny/24/Cote-dIvoire.png": "6c4e",
	"./shiny/24/Croatia.png": "17dd",
	"./shiny/24/Cuba.png": "5bbc",
	"./shiny/24/Curacao.png": "4cd6",
	"./shiny/24/Cyprus.png": "d727",
	"./shiny/24/Czech-Republic.png": "71a0",
	"./shiny/24/Democratic-Republic-of-the-Congo.png": "ef65",
	"./shiny/24/Denmark.png": "598a",
	"./shiny/24/Djibouti.png": "56b8",
	"./shiny/24/Dominica.png": "dd78",
	"./shiny/24/Dominican-Republic.png": "842f",
	"./shiny/24/East-Timor.png": "781a",
	"./shiny/24/Ecuador.png": "2580",
	"./shiny/24/Egypt.png": "079e",
	"./shiny/24/El-Salvador.png": "ce00",
	"./shiny/24/England.png": "88b7",
	"./shiny/24/Equatorial-Guinea.png": "521c",
	"./shiny/24/Eritrea.png": "8f34",
	"./shiny/24/Estonia.png": "8ea1",
	"./shiny/24/Ethiopia.png": "057d",
	"./shiny/24/European-Union.png": "faed",
	"./shiny/24/Falkland-Islands.png": "6b63",
	"./shiny/24/Faroes.png": "fe25",
	"./shiny/24/Fiji.png": "5938",
	"./shiny/24/Finland.png": "305d",
	"./shiny/24/France.png": "79b6",
	"./shiny/24/French-Polynesia.png": "0e36",
	"./shiny/24/French-Southern-Territories.png": "6127",
	"./shiny/24/Gabon.png": "1259",
	"./shiny/24/Gambia.png": "f10d",
	"./shiny/24/Georgia.png": "2604",
	"./shiny/24/Germany.png": "5334",
	"./shiny/24/Ghana.png": "12c4",
	"./shiny/24/Gibraltar.png": "9033",
	"./shiny/24/GoSquared.png": "fc88",
	"./shiny/24/Greece.png": "2f16",
	"./shiny/24/Greenland.png": "8da0",
	"./shiny/24/Grenada.png": "965d",
	"./shiny/24/Guam.png": "9c64",
	"./shiny/24/Guatemala.png": "da46",
	"./shiny/24/Guernsey.png": "2cbf",
	"./shiny/24/Guinea-Bissau.png": "040e",
	"./shiny/24/Guinea.png": "51d3",
	"./shiny/24/Guyana.png": "521f",
	"./shiny/24/Haiti.png": "bdb3",
	"./shiny/24/Honduras.png": "065a4",
	"./shiny/24/Hong-Kong.png": "4935",
	"./shiny/24/Hungary.png": "789f",
	"./shiny/24/Iceland.png": "9739",
	"./shiny/24/India.png": "0375",
	"./shiny/24/Indonesia.png": "c8bf",
	"./shiny/24/Iran.png": "82b8",
	"./shiny/24/Iraq.png": "9885",
	"./shiny/24/Ireland.png": "4433",
	"./shiny/24/Isle-of-Man.png": "1936",
	"./shiny/24/Israel.png": "eb83",
	"./shiny/24/Italy.png": "7828",
	"./shiny/24/Jamaica.png": "b0fd",
	"./shiny/24/Japan.png": "f8956",
	"./shiny/24/Jersey.png": "e995",
	"./shiny/24/Jordan.png": "9d48",
	"./shiny/24/Kazakhstan.png": "42e8",
	"./shiny/24/Kenya.png": "3c0b",
	"./shiny/24/Kiribati.png": "9c80b",
	"./shiny/24/Kosovo.png": "8634",
	"./shiny/24/Kuwait.png": "24a1",
	"./shiny/24/Kyrgyzstan.png": "124d",
	"./shiny/24/Laos.png": "983f",
	"./shiny/24/Latvia.png": "6d6ce",
	"./shiny/24/Lebanon.png": "2237",
	"./shiny/24/Lesotho.png": "8570",
	"./shiny/24/Liberia.png": "164d",
	"./shiny/24/Libya.png": "12e5",
	"./shiny/24/Liechtenstein.png": "0df8",
	"./shiny/24/Lithuania.png": "a751",
	"./shiny/24/Luxembourg.png": "7518",
	"./shiny/24/Macau.png": "9c53",
	"./shiny/24/Macedonia.png": "d144",
	"./shiny/24/Madagascar.png": "a4d1",
	"./shiny/24/Malawi.png": "15e2",
	"./shiny/24/Malaysia.png": "f7f4",
	"./shiny/24/Maldives.png": "3214",
	"./shiny/24/Mali.png": "7b60",
	"./shiny/24/Malta.png": "0893",
	"./shiny/24/Mars.png": "edcd4",
	"./shiny/24/Marshall-Islands.png": "525c",
	"./shiny/24/Martinique.png": "10ad",
	"./shiny/24/Mauritania.png": "e7a9",
	"./shiny/24/Mauritius.png": "1387",
	"./shiny/24/Mayotte.png": "57f9",
	"./shiny/24/Mexico.png": "df6d",
	"./shiny/24/Micronesia.png": "d418",
	"./shiny/24/Moldova.png": "44d0",
	"./shiny/24/Monaco.png": "c981",
	"./shiny/24/Mongolia.png": "cebf",
	"./shiny/24/Montenegro.png": "aea2",
	"./shiny/24/Montserrat.png": "b7a0",
	"./shiny/24/Morocco.png": "80d5",
	"./shiny/24/Mozambique.png": "7483",
	"./shiny/24/Myanmar.png": "e7bcf",
	"./shiny/24/NATO.png": "320f",
	"./shiny/24/Nagorno-Karabakh.png": "1b2b",
	"./shiny/24/Namibia.png": "33d7",
	"./shiny/24/Nauru.png": "c103",
	"./shiny/24/Nepal.png": "1f63",
	"./shiny/24/Netherlands-Antilles.png": "378c",
	"./shiny/24/Netherlands.png": "753e",
	"./shiny/24/New-Caledonia.png": "7abc",
	"./shiny/24/New-Zealand.png": "23d6",
	"./shiny/24/Nicaragua.png": "4137",
	"./shiny/24/Niger.png": "eaa7",
	"./shiny/24/Nigeria.png": "59de",
	"./shiny/24/Niue.png": "47ad",
	"./shiny/24/Norfolk-Island.png": "5d91",
	"./shiny/24/North-Korea.png": "c114",
	"./shiny/24/Northern-Cyprus.png": "0b44",
	"./shiny/24/Northern-Mariana-Islands.png": "bc35",
	"./shiny/24/Norway.png": "fde1",
	"./shiny/24/Olympics.png": "9e90",
	"./shiny/24/Oman.png": "6a42",
	"./shiny/24/Pakistan.png": "7a7d",
	"./shiny/24/Palau.png": "3794",
	"./shiny/24/Palestine.png": "9eb3",
	"./shiny/24/Panama.png": "3e64",
	"./shiny/24/Papua-New-Guinea.png": "5383",
	"./shiny/24/Paraguay.png": "a9a1",
	"./shiny/24/Peru.png": "bbe5",
	"./shiny/24/Philippines.png": "0cef",
	"./shiny/24/Pitcairn-Islands.png": "78f2",
	"./shiny/24/Poland.png": "ef6e",
	"./shiny/24/Portugal.png": "4242",
	"./shiny/24/Puerto-Rico.png": "8496",
	"./shiny/24/Qatar.png": "0e48",
	"./shiny/24/Red-Cross.png": "b6bb",
	"./shiny/24/Republic-of-the-Congo.png": "0f85",
	"./shiny/24/Romania.png": "4e25",
	"./shiny/24/Russia.png": "dab0",
	"./shiny/24/Rwanda.png": "b28d",
	"./shiny/24/Saint-Barthelemy.png": "53eb",
	"./shiny/24/Saint-Helena.png": "cd16",
	"./shiny/24/Saint-Kitts-and-Nevis.png": "cb90",
	"./shiny/24/Saint-Lucia.png": "8733",
	"./shiny/24/Saint-Martin.png": "c3b4",
	"./shiny/24/Saint-Vincent-and-the-Grenadines.png": "1be7",
	"./shiny/24/Samoa.png": "013c",
	"./shiny/24/San-Marino.png": "658a",
	"./shiny/24/Sao-Tome-and-Principe.png": "daa2",
	"./shiny/24/Saudi-Arabia.png": "9071",
	"./shiny/24/Scotland.png": "401d",
	"./shiny/24/Senegal.png": "ef1c",
	"./shiny/24/Serbia.png": "24d4",
	"./shiny/24/Seychelles.png": "aaa0",
	"./shiny/24/Sierra-Leone.png": "43cd",
	"./shiny/24/Singapore.png": "8bec",
	"./shiny/24/Slovakia.png": "abfc",
	"./shiny/24/Slovenia.png": "4e70",
	"./shiny/24/Solomon-Islands.png": "c62f",
	"./shiny/24/Somalia.png": "c536",
	"./shiny/24/Somaliland.png": "f701",
	"./shiny/24/South-Africa.png": "2011",
	"./shiny/24/South-Georgia-and-the-South-Sandwich-Islands.png": "0751",
	"./shiny/24/South-Korea.png": "2c26",
	"./shiny/24/South-Ossetia.png": "3bb46",
	"./shiny/24/South-Sudan.png": "44c7",
	"./shiny/24/Spain.png": "61ec",
	"./shiny/24/Sri-Lanka.png": "10e87",
	"./shiny/24/Sudan.png": "e61f",
	"./shiny/24/Suriname.png": "6c74",
	"./shiny/24/Swaziland.png": "3c38",
	"./shiny/24/Sweden.png": "8f7a",
	"./shiny/24/Switzerland.png": "e586",
	"./shiny/24/Syria.png": "66ce",
	"./shiny/24/Taiwan.png": "4818",
	"./shiny/24/Tajikistan.png": "5bec",
	"./shiny/24/Tanzania.png": "7d2b",
	"./shiny/24/Thailand.png": "6ea3",
	"./shiny/24/Togo.png": "c7bd",
	"./shiny/24/Tokelau.png": "72d7",
	"./shiny/24/Tonga.png": "3773",
	"./shiny/24/Trinidad-and-Tobago.png": "bcb55",
	"./shiny/24/Tunisia.png": "4ac4",
	"./shiny/24/Turkey.png": "cfb4",
	"./shiny/24/Turkmenistan.png": "ff52",
	"./shiny/24/Turks-and-Caicos-Islands.png": "10f2",
	"./shiny/24/Tuvalu.png": "e555",
	"./shiny/24/US-Virgin-Islands.png": "775fb",
	"./shiny/24/Uganda.png": "d206",
	"./shiny/24/Ukraine.png": "e6c6",
	"./shiny/24/United-Arab-Emirates.png": "b280",
	"./shiny/24/United-Kingdom.png": "93b7",
	"./shiny/24/United-Nations.png": "ea26",
	"./shiny/24/United-States.png": "9b66",
	"./shiny/24/Unknown.png": "7498",
	"./shiny/24/Uruguay.png": "5502",
	"./shiny/24/Uzbekistan.png": "bf9f",
	"./shiny/24/Vanuatu.png": "8ea8",
	"./shiny/24/Vatican-City.png": "aa39",
	"./shiny/24/Venezuela.png": "ee6d",
	"./shiny/24/Vietnam.png": "ab45",
	"./shiny/24/Wales.png": "81e5",
	"./shiny/24/Wallis-And-Futuna.png": "bd56",
	"./shiny/24/Western-Sahara.png": "eb55",
	"./shiny/24/Yemen.png": "550e",
	"./shiny/24/Zambia.png": "b963",
	"./shiny/24/Zimbabwe.png": "e787",
	"./shiny/32/Abkhazia.png": "06b4",
	"./shiny/32/Afghanistan.png": "89b9",
	"./shiny/32/Aland.png": "d8d3",
	"./shiny/32/Albania.png": "3524",
	"./shiny/32/Algeria.png": "24ce",
	"./shiny/32/American-Samoa.png": "a35a",
	"./shiny/32/Andorra.png": "2ab2",
	"./shiny/32/Angola.png": "3fac",
	"./shiny/32/Anguilla.png": "ecb8",
	"./shiny/32/Antarctica.png": "734f",
	"./shiny/32/Antigua-and-Barbuda.png": "8013",
	"./shiny/32/Argentina.png": "4c3b",
	"./shiny/32/Armenia.png": "aa97",
	"./shiny/32/Aruba.png": "7362",
	"./shiny/32/Australia.png": "d2eb",
	"./shiny/32/Austria.png": "e6d0",
	"./shiny/32/Azerbaijan.png": "0250",
	"./shiny/32/Bahamas.png": "a24d",
	"./shiny/32/Bahrain.png": "019f",
	"./shiny/32/Bangladesh.png": "1fa1",
	"./shiny/32/Barbados.png": "5d03",
	"./shiny/32/Basque-Country.png": "5b42",
	"./shiny/32/Belarus.png": "9a50",
	"./shiny/32/Belgium.png": "6653",
	"./shiny/32/Belize.png": "1f99",
	"./shiny/32/Benin.png": "1502",
	"./shiny/32/Bermuda.png": "7b44",
	"./shiny/32/Bhutan.png": "a484",
	"./shiny/32/Bolivia.png": "8bee",
	"./shiny/32/Bosnia-and-Herzegovina.png": "3a93",
	"./shiny/32/Botswana.png": "13ed",
	"./shiny/32/Brazil.png": "26b7",
	"./shiny/32/British-Antarctic-Territory.png": "99bc",
	"./shiny/32/British-Virgin-Islands.png": "37cf",
	"./shiny/32/Brunei.png": "b30d",
	"./shiny/32/Bulgaria.png": "1959",
	"./shiny/32/Burkina-Faso.png": "3d4c",
	"./shiny/32/Burundi.png": "d9e7",
	"./shiny/32/Cambodia.png": "81be",
	"./shiny/32/Cameroon.png": "10dc",
	"./shiny/32/Canada.png": "a04d",
	"./shiny/32/Canary-Islands.png": "d964",
	"./shiny/32/Cape-Verde.png": "2694",
	"./shiny/32/Cayman-Islands.png": "5233",
	"./shiny/32/Central-African-Republic.png": "3d0a",
	"./shiny/32/Chad.png": "5a6a",
	"./shiny/32/Chile.png": "d00c",
	"./shiny/32/China.png": "8d520",
	"./shiny/32/Christmas-Island.png": "2568",
	"./shiny/32/Cocos-Keeling-Islands.png": "901eb",
	"./shiny/32/Colombia.png": "9086",
	"./shiny/32/Commonwealth.png": "3513",
	"./shiny/32/Comoros.png": "e926",
	"./shiny/32/Cook-Islands.png": "79e8",
	"./shiny/32/Costa-Rica.png": "2e73",
	"./shiny/32/Cote-dIvoire.png": "3ee2",
	"./shiny/32/Croatia.png": "c569",
	"./shiny/32/Cuba.png": "408b",
	"./shiny/32/Curacao.png": "56a2",
	"./shiny/32/Cyprus.png": "076c",
	"./shiny/32/Czech-Republic.png": "986c",
	"./shiny/32/Democratic-Republic-of-the-Congo.png": "2292",
	"./shiny/32/Denmark.png": "de44",
	"./shiny/32/Djibouti.png": "ebf6",
	"./shiny/32/Dominica.png": "e1a2",
	"./shiny/32/Dominican-Republic.png": "969c",
	"./shiny/32/East-Timor.png": "379e",
	"./shiny/32/Ecuador.png": "f4e8",
	"./shiny/32/Egypt.png": "0c45",
	"./shiny/32/El-Salvador.png": "dc3f",
	"./shiny/32/England.png": "c430",
	"./shiny/32/Equatorial-Guinea.png": "0725",
	"./shiny/32/Eritrea.png": "e76a",
	"./shiny/32/Estonia.png": "156a",
	"./shiny/32/Ethiopia.png": "8f34a",
	"./shiny/32/European-Union.png": "a610",
	"./shiny/32/Falkland-Islands.png": "ae14",
	"./shiny/32/Faroes.png": "fe05",
	"./shiny/32/Fiji.png": "6180",
	"./shiny/32/Finland.png": "48da",
	"./shiny/32/France.png": "d6a0",
	"./shiny/32/French-Polynesia.png": "7837",
	"./shiny/32/French-Southern-Territories.png": "0458",
	"./shiny/32/Gabon.png": "1d32",
	"./shiny/32/Gambia.png": "3024",
	"./shiny/32/Georgia.png": "4543",
	"./shiny/32/Germany.png": "6f46",
	"./shiny/32/Ghana.png": "4d3f",
	"./shiny/32/Gibraltar.png": "d59d",
	"./shiny/32/GoSquared.png": "0cb9",
	"./shiny/32/Greece.png": "544c",
	"./shiny/32/Greenland.png": "ee80",
	"./shiny/32/Grenada.png": "4b3b",
	"./shiny/32/Guam.png": "b5e0",
	"./shiny/32/Guatemala.png": "1b1e",
	"./shiny/32/Guernsey.png": "d38d",
	"./shiny/32/Guinea-Bissau.png": "7cfc",
	"./shiny/32/Guinea.png": "cd3b",
	"./shiny/32/Guyana.png": "fd35",
	"./shiny/32/Haiti.png": "1329f",
	"./shiny/32/Honduras.png": "6bff",
	"./shiny/32/Hong-Kong.png": "fd80",
	"./shiny/32/Hungary.png": "f072",
	"./shiny/32/Iceland.png": "bcc6",
	"./shiny/32/India.png": "8933",
	"./shiny/32/Indonesia.png": "76c5",
	"./shiny/32/Iran.png": "2d1b",
	"./shiny/32/Iraq.png": "bf3b",
	"./shiny/32/Ireland.png": "07e0",
	"./shiny/32/Isle-of-Man.png": "5d05",
	"./shiny/32/Israel.png": "91c0",
	"./shiny/32/Italy.png": "e03b",
	"./shiny/32/Jamaica.png": "c683",
	"./shiny/32/Japan.png": "f4d69",
	"./shiny/32/Jersey.png": "7ce0",
	"./shiny/32/Jordan.png": "dd88",
	"./shiny/32/Kazakhstan.png": "a69e2",
	"./shiny/32/Kenya.png": "9fc2",
	"./shiny/32/Kiribati.png": "b8ea",
	"./shiny/32/Kosovo.png": "34b1",
	"./shiny/32/Kuwait.png": "44a3",
	"./shiny/32/Kyrgyzstan.png": "fb73",
	"./shiny/32/Laos.png": "f407",
	"./shiny/32/Latvia.png": "7a8b",
	"./shiny/32/Lebanon.png": "3f09",
	"./shiny/32/Lesotho.png": "57df",
	"./shiny/32/Liberia.png": "62f2",
	"./shiny/32/Libya.png": "2a76",
	"./shiny/32/Liechtenstein.png": "371c",
	"./shiny/32/Lithuania.png": "bf8b",
	"./shiny/32/Luxembourg.png": "b06f6",
	"./shiny/32/Macau.png": "5eb0",
	"./shiny/32/Macedonia.png": "1401",
	"./shiny/32/Madagascar.png": "c13d",
	"./shiny/32/Malawi.png": "66e9",
	"./shiny/32/Malaysia.png": "b28e",
	"./shiny/32/Maldives.png": "49c3",
	"./shiny/32/Mali.png": "1358",
	"./shiny/32/Malta.png": "8c09",
	"./shiny/32/Mars.png": "4be0",
	"./shiny/32/Marshall-Islands.png": "f617",
	"./shiny/32/Martinique.png": "668d",
	"./shiny/32/Mauritania.png": "a083",
	"./shiny/32/Mauritius.png": "ba70",
	"./shiny/32/Mayotte.png": "2926",
	"./shiny/32/Mexico.png": "cd9f",
	"./shiny/32/Micronesia.png": "317c",
	"./shiny/32/Moldova.png": "5dea",
	"./shiny/32/Monaco.png": "944f",
	"./shiny/32/Mongolia.png": "9a7e",
	"./shiny/32/Montenegro.png": "e81f",
	"./shiny/32/Montserrat.png": "d9dd",
	"./shiny/32/Morocco.png": "9050",
	"./shiny/32/Mozambique.png": "b32e",
	"./shiny/32/Myanmar.png": "9018",
	"./shiny/32/NATO.png": "faf66",
	"./shiny/32/Nagorno-Karabakh.png": "70b0",
	"./shiny/32/Namibia.png": "95a6",
	"./shiny/32/Nauru.png": "0931",
	"./shiny/32/Nepal.png": "4183",
	"./shiny/32/Netherlands-Antilles.png": "e144",
	"./shiny/32/Netherlands.png": "e503",
	"./shiny/32/New-Caledonia.png": "54d2",
	"./shiny/32/New-Zealand.png": "8eba",
	"./shiny/32/Nicaragua.png": "be6d",
	"./shiny/32/Niger.png": "039c",
	"./shiny/32/Nigeria.png": "6df6",
	"./shiny/32/Niue.png": "fcd1",
	"./shiny/32/Norfolk-Island.png": "17bd",
	"./shiny/32/North-Korea.png": "c14d",
	"./shiny/32/Northern-Cyprus.png": "051f",
	"./shiny/32/Northern-Mariana-Islands.png": "f81c",
	"./shiny/32/Norway.png": "f74c",
	"./shiny/32/Olympics.png": "ba56",
	"./shiny/32/Oman.png": "5c50",
	"./shiny/32/Pakistan.png": "2f71",
	"./shiny/32/Palau.png": "6984",
	"./shiny/32/Palestine.png": "d82c",
	"./shiny/32/Panama.png": "e32b",
	"./shiny/32/Papua-New-Guinea.png": "3175",
	"./shiny/32/Paraguay.png": "c992",
	"./shiny/32/Peru.png": "9c2f",
	"./shiny/32/Philippines.png": "179e",
	"./shiny/32/Pitcairn-Islands.png": "152f",
	"./shiny/32/Poland.png": "e889",
	"./shiny/32/Portugal.png": "0d7a",
	"./shiny/32/Puerto-Rico.png": "f648",
	"./shiny/32/Qatar.png": "442f",
	"./shiny/32/Red-Cross.png": "b4f8",
	"./shiny/32/Republic-of-the-Congo.png": "e7e3",
	"./shiny/32/Romania.png": "bd2d",
	"./shiny/32/Russia.png": "a5a4",
	"./shiny/32/Rwanda.png": "0b87",
	"./shiny/32/Saint-Barthelemy.png": "7086",
	"./shiny/32/Saint-Helena.png": "a400",
	"./shiny/32/Saint-Kitts-and-Nevis.png": "fb13",
	"./shiny/32/Saint-Lucia.png": "135c",
	"./shiny/32/Saint-Martin.png": "1942",
	"./shiny/32/Saint-Vincent-and-the-Grenadines.png": "6f9a",
	"./shiny/32/Samoa.png": "e942",
	"./shiny/32/San-Marino.png": "1972",
	"./shiny/32/Sao-Tome-and-Principe.png": "7ea0",
	"./shiny/32/Saudi-Arabia.png": "ab55",
	"./shiny/32/Scotland.png": "4f78",
	"./shiny/32/Senegal.png": "038a",
	"./shiny/32/Serbia.png": "215f",
	"./shiny/32/Seychelles.png": "dab3",
	"./shiny/32/Sierra-Leone.png": "2e3f",
	"./shiny/32/Singapore.png": "1943",
	"./shiny/32/Slovakia.png": "0391",
	"./shiny/32/Slovenia.png": "c8ec",
	"./shiny/32/Solomon-Islands.png": "b6a2",
	"./shiny/32/Somalia.png": "be21",
	"./shiny/32/Somaliland.png": "c876",
	"./shiny/32/South-Africa.png": "ec24",
	"./shiny/32/South-Georgia-and-the-South-Sandwich-Islands.png": "fdfc",
	"./shiny/32/South-Korea.png": "cc4a",
	"./shiny/32/South-Ossetia.png": "9996a",
	"./shiny/32/South-Sudan.png": "36d3",
	"./shiny/32/Spain.png": "00b4",
	"./shiny/32/Sri-Lanka.png": "9732",
	"./shiny/32/Sudan.png": "b902",
	"./shiny/32/Suriname.png": "70fc",
	"./shiny/32/Swaziland.png": "4800a",
	"./shiny/32/Sweden.png": "0dee",
	"./shiny/32/Switzerland.png": "a844",
	"./shiny/32/Syria.png": "acbb",
	"./shiny/32/Taiwan.png": "b237",
	"./shiny/32/Tajikistan.png": "8ae0",
	"./shiny/32/Tanzania.png": "8acf",
	"./shiny/32/Thailand.png": "a054",
	"./shiny/32/Togo.png": "bafb",
	"./shiny/32/Tokelau.png": "e5a4",
	"./shiny/32/Tonga.png": "6ef9",
	"./shiny/32/Trinidad-and-Tobago.png": "3015",
	"./shiny/32/Tunisia.png": "f6a7",
	"./shiny/32/Turkey.png": "d4fc",
	"./shiny/32/Turkmenistan.png": "5865",
	"./shiny/32/Turks-and-Caicos-Islands.png": "8a36",
	"./shiny/32/Tuvalu.png": "922c",
	"./shiny/32/US-Virgin-Islands.png": "2e5e",
	"./shiny/32/Uganda.png": "7a91",
	"./shiny/32/Ukraine.png": "db21",
	"./shiny/32/United-Arab-Emirates.png": "93c5",
	"./shiny/32/United-Kingdom.png": "0d1d",
	"./shiny/32/United-Nations.png": "c474",
	"./shiny/32/United-States.png": "6bc7",
	"./shiny/32/Unknown.png": "f58e",
	"./shiny/32/Uruguay.png": "a44a",
	"./shiny/32/Uzbekistan.png": "72ef",
	"./shiny/32/Vanuatu.png": "2266",
	"./shiny/32/Vatican-City.png": "4307",
	"./shiny/32/Venezuela.png": "d3a9",
	"./shiny/32/Vietnam.png": "984f",
	"./shiny/32/Wales.png": "f49d",
	"./shiny/32/Wallis-And-Futuna.png": "5725",
	"./shiny/32/Western-Sahara.png": "8ee5",
	"./shiny/32/Yemen.png": "abe8",
	"./shiny/32/Zambia.png": "1005",
	"./shiny/32/Zimbabwe.png": "2e55",
	"./shiny/48/Abkhazia.png": "6fb2",
	"./shiny/48/Afghanistan.png": "cd33",
	"./shiny/48/Aland.png": "7b8a",
	"./shiny/48/Albania.png": "9f59",
	"./shiny/48/Algeria.png": "8bc0",
	"./shiny/48/American-Samoa.png": "0893a",
	"./shiny/48/Andorra.png": "2813",
	"./shiny/48/Angola.png": "16c9",
	"./shiny/48/Anguilla.png": "afdb",
	"./shiny/48/Antarctica.png": "3b06",
	"./shiny/48/Antigua-and-Barbuda.png": "5f7b",
	"./shiny/48/Argentina.png": "5c1e",
	"./shiny/48/Armenia.png": "b595",
	"./shiny/48/Aruba.png": "53b0",
	"./shiny/48/Australia.png": "c5f2",
	"./shiny/48/Austria.png": "23e4",
	"./shiny/48/Azerbaijan.png": "b4296",
	"./shiny/48/Bahamas.png": "1650",
	"./shiny/48/Bahrain.png": "4a90",
	"./shiny/48/Bangladesh.png": "c3d5",
	"./shiny/48/Barbados.png": "3dae",
	"./shiny/48/Basque-Country.png": "5998",
	"./shiny/48/Belarus.png": "c595",
	"./shiny/48/Belgium.png": "5297",
	"./shiny/48/Belize.png": "6e7d",
	"./shiny/48/Benin.png": "fba7",
	"./shiny/48/Bermuda.png": "27bd",
	"./shiny/48/Bhutan.png": "2d34",
	"./shiny/48/Bolivia.png": "8ba3",
	"./shiny/48/Bosnia-and-Herzegovina.png": "d42d",
	"./shiny/48/Botswana.png": "9a7a",
	"./shiny/48/Brazil.png": "4e677",
	"./shiny/48/British-Antarctic-Territory.png": "e754",
	"./shiny/48/British-Virgin-Islands.png": "8fd2",
	"./shiny/48/Brunei.png": "801c",
	"./shiny/48/Bulgaria.png": "3b00",
	"./shiny/48/Burkina-Faso.png": "2bda",
	"./shiny/48/Burundi.png": "2fda",
	"./shiny/48/Cambodia.png": "768f",
	"./shiny/48/Cameroon.png": "ea04",
	"./shiny/48/Canada.png": "aff5",
	"./shiny/48/Canary-Islands.png": "fc7e",
	"./shiny/48/Cape-Verde.png": "11e7",
	"./shiny/48/Cayman-Islands.png": "633b",
	"./shiny/48/Central-African-Republic.png": "a3da",
	"./shiny/48/Chad.png": "1ff3",
	"./shiny/48/Chile.png": "d5ad",
	"./shiny/48/China.png": "44b9",
	"./shiny/48/Christmas-Island.png": "4dc7",
	"./shiny/48/Cocos-Keeling-Islands.png": "6289",
	"./shiny/48/Colombia.png": "8d62",
	"./shiny/48/Commonwealth.png": "2683",
	"./shiny/48/Comoros.png": "dabf",
	"./shiny/48/Cook-Islands.png": "ab2e",
	"./shiny/48/Costa-Rica.png": "1e7e5",
	"./shiny/48/Cote-dIvoire.png": "d7e0",
	"./shiny/48/Croatia.png": "1085",
	"./shiny/48/Cuba.png": "c86d",
	"./shiny/48/Curacao.png": "9bbb",
	"./shiny/48/Cyprus.png": "6b488",
	"./shiny/48/Czech-Republic.png": "90d2",
	"./shiny/48/Democratic-Republic-of-the-Congo.png": "1458",
	"./shiny/48/Denmark.png": "8975",
	"./shiny/48/Djibouti.png": "b9d7",
	"./shiny/48/Dominica.png": "7061",
	"./shiny/48/Dominican-Republic.png": "cbd1",
	"./shiny/48/East-Timor.png": "6339",
	"./shiny/48/Ecuador.png": "e615",
	"./shiny/48/Egypt.png": "a828",
	"./shiny/48/El-Salvador.png": "1b2e",
	"./shiny/48/England.png": "8ab8",
	"./shiny/48/Equatorial-Guinea.png": "71d3",
	"./shiny/48/Eritrea.png": "c7c6",
	"./shiny/48/Estonia.png": "2e13",
	"./shiny/48/Ethiopia.png": "0d67",
	"./shiny/48/European-Union.png": "2306",
	"./shiny/48/Falkland-Islands.png": "2f66",
	"./shiny/48/Faroes.png": "4443",
	"./shiny/48/Fiji.png": "d563",
	"./shiny/48/Finland.png": "7bc0",
	"./shiny/48/France.png": "8a38",
	"./shiny/48/French-Polynesia.png": "845f",
	"./shiny/48/French-Southern-Territories.png": "00ce8",
	"./shiny/48/Gabon.png": "2a77",
	"./shiny/48/Gambia.png": "fd24",
	"./shiny/48/Georgia.png": "f901",
	"./shiny/48/Germany.png": "75f2",
	"./shiny/48/Ghana.png": "03f2",
	"./shiny/48/Gibraltar.png": "bfd5",
	"./shiny/48/GoSquared.png": "d010",
	"./shiny/48/Greece.png": "bb10",
	"./shiny/48/Greenland.png": "3e1d",
	"./shiny/48/Grenada.png": "4719",
	"./shiny/48/Guam.png": "a1dc",
	"./shiny/48/Guatemala.png": "a82a",
	"./shiny/48/Guernsey.png": "af9c",
	"./shiny/48/Guinea-Bissau.png": "e9a4",
	"./shiny/48/Guinea.png": "cfd5",
	"./shiny/48/Guyana.png": "a155",
	"./shiny/48/Haiti.png": "02a2",
	"./shiny/48/Honduras.png": "3c49",
	"./shiny/48/Hong-Kong.png": "abd0",
	"./shiny/48/Hungary.png": "e719",
	"./shiny/48/Iceland.png": "8fb0",
	"./shiny/48/India.png": "092c",
	"./shiny/48/Indonesia.png": "bc5b",
	"./shiny/48/Iran.png": "1b42",
	"./shiny/48/Iraq.png": "ac00",
	"./shiny/48/Ireland.png": "b2cc",
	"./shiny/48/Isle-of-Man.png": "13c1",
	"./shiny/48/Israel.png": "553a",
	"./shiny/48/Italy.png": "eb9a",
	"./shiny/48/Jamaica.png": "24c1",
	"./shiny/48/Japan.png": "74f6",
	"./shiny/48/Jersey.png": "efab",
	"./shiny/48/Jordan.png": "6117",
	"./shiny/48/Kazakhstan.png": "53d8",
	"./shiny/48/Kenya.png": "8a79",
	"./shiny/48/Kiribati.png": "ef38",
	"./shiny/48/Kosovo.png": "ee76",
	"./shiny/48/Kuwait.png": "d7db",
	"./shiny/48/Kyrgyzstan.png": "f9e5",
	"./shiny/48/Laos.png": "9a20",
	"./shiny/48/Latvia.png": "96dc",
	"./shiny/48/Lebanon.png": "83d4",
	"./shiny/48/Lesotho.png": "3492",
	"./shiny/48/Liberia.png": "3b6c",
	"./shiny/48/Libya.png": "55f3",
	"./shiny/48/Liechtenstein.png": "496c",
	"./shiny/48/Lithuania.png": "c862",
	"./shiny/48/Luxembourg.png": "bcad",
	"./shiny/48/Macau.png": "f771",
	"./shiny/48/Macedonia.png": "8e32",
	"./shiny/48/Madagascar.png": "f133",
	"./shiny/48/Malawi.png": "a5f3",
	"./shiny/48/Malaysia.png": "0249",
	"./shiny/48/Maldives.png": "476d",
	"./shiny/48/Mali.png": "e64b",
	"./shiny/48/Malta.png": "080b",
	"./shiny/48/Mars.png": "3103",
	"./shiny/48/Marshall-Islands.png": "3c48",
	"./shiny/48/Martinique.png": "d2e0",
	"./shiny/48/Mauritania.png": "1512",
	"./shiny/48/Mauritius.png": "5661",
	"./shiny/48/Mayotte.png": "d9c6",
	"./shiny/48/Mexico.png": "bff4",
	"./shiny/48/Micronesia.png": "fc882",
	"./shiny/48/Moldova.png": "8689",
	"./shiny/48/Monaco.png": "176a",
	"./shiny/48/Mongolia.png": "40a1",
	"./shiny/48/Montenegro.png": "3da5",
	"./shiny/48/Montserrat.png": "26f0",
	"./shiny/48/Morocco.png": "549f",
	"./shiny/48/Mozambique.png": "b579",
	"./shiny/48/Myanmar.png": "d79b",
	"./shiny/48/NATO.png": "37cd",
	"./shiny/48/Nagorno-Karabakh.png": "576d",
	"./shiny/48/Namibia.png": "7474",
	"./shiny/48/Nauru.png": "25c7",
	"./shiny/48/Nepal.png": "a435",
	"./shiny/48/Netherlands-Antilles.png": "bf418",
	"./shiny/48/Netherlands.png": "96c7",
	"./shiny/48/New-Caledonia.png": "ce6f",
	"./shiny/48/New-Zealand.png": "bcde",
	"./shiny/48/Nicaragua.png": "fe36",
	"./shiny/48/Niger.png": "43a2",
	"./shiny/48/Nigeria.png": "7606",
	"./shiny/48/Niue.png": "1105",
	"./shiny/48/Norfolk-Island.png": "0af2",
	"./shiny/48/North-Korea.png": "c57f",
	"./shiny/48/Northern-Cyprus.png": "d469",
	"./shiny/48/Northern-Mariana-Islands.png": "2874",
	"./shiny/48/Norway.png": "9f6f",
	"./shiny/48/Olympics.png": "a93d",
	"./shiny/48/Oman.png": "e3b7",
	"./shiny/48/Pakistan.png": "1357",
	"./shiny/48/Palau.png": "3b33",
	"./shiny/48/Palestine.png": "f33e",
	"./shiny/48/Panama.png": "e75c",
	"./shiny/48/Papua-New-Guinea.png": "ba68",
	"./shiny/48/Paraguay.png": "0897",
	"./shiny/48/Peru.png": "84ef",
	"./shiny/48/Philippines.png": "93629",
	"./shiny/48/Pitcairn-Islands.png": "17ec",
	"./shiny/48/Poland.png": "c0c2",
	"./shiny/48/Portugal.png": "0364",
	"./shiny/48/Puerto-Rico.png": "0e18",
	"./shiny/48/Qatar.png": "e212",
	"./shiny/48/Red-Cross.png": "afe2",
	"./shiny/48/Republic-of-the-Congo.png": "a3bc",
	"./shiny/48/Romania.png": "6954",
	"./shiny/48/Russia.png": "f0e9",
	"./shiny/48/Rwanda.png": "9be4",
	"./shiny/48/Saint-Barthelemy.png": "37e6",
	"./shiny/48/Saint-Helena.png": "7e9f",
	"./shiny/48/Saint-Kitts-and-Nevis.png": "6ec5",
	"./shiny/48/Saint-Lucia.png": "1faa",
	"./shiny/48/Saint-Martin.png": "bb5e",
	"./shiny/48/Saint-Vincent-and-the-Grenadines.png": "3e27",
	"./shiny/48/Samoa.png": "569d",
	"./shiny/48/San-Marino.png": "0746",
	"./shiny/48/Sao-Tome-and-Principe.png": "f1da",
	"./shiny/48/Saudi-Arabia.png": "556f",
	"./shiny/48/Scotland.png": "17e3",
	"./shiny/48/Senegal.png": "5546",
	"./shiny/48/Serbia.png": "da77",
	"./shiny/48/Seychelles.png": "a99d",
	"./shiny/48/Sierra-Leone.png": "6454",
	"./shiny/48/Singapore.png": "c539",
	"./shiny/48/Slovakia.png": "cef8",
	"./shiny/48/Slovenia.png": "1b11",
	"./shiny/48/Solomon-Islands.png": "3706",
	"./shiny/48/Somalia.png": "d0ab",
	"./shiny/48/Somaliland.png": "5a05",
	"./shiny/48/South-Africa.png": "0a17",
	"./shiny/48/South-Georgia-and-the-South-Sandwich-Islands.png": "1c3b",
	"./shiny/48/South-Korea.png": "ea5a",
	"./shiny/48/South-Ossetia.png": "1ca5",
	"./shiny/48/South-Sudan.png": "0be1",
	"./shiny/48/Spain.png": "79bf",
	"./shiny/48/Sri-Lanka.png": "e34c",
	"./shiny/48/Sudan.png": "0fb7",
	"./shiny/48/Suriname.png": "c4f4",
	"./shiny/48/Swaziland.png": "8ce2",
	"./shiny/48/Sweden.png": "5267",
	"./shiny/48/Switzerland.png": "221b",
	"./shiny/48/Syria.png": "a5cc",
	"./shiny/48/Taiwan.png": "d22b",
	"./shiny/48/Tajikistan.png": "14de",
	"./shiny/48/Tanzania.png": "ef6c",
	"./shiny/48/Thailand.png": "813f",
	"./shiny/48/Togo.png": "9e52",
	"./shiny/48/Tokelau.png": "2055",
	"./shiny/48/Tonga.png": "f1c4",
	"./shiny/48/Trinidad-and-Tobago.png": "19b5",
	"./shiny/48/Tunisia.png": "b807",
	"./shiny/48/Turkey.png": "42a5",
	"./shiny/48/Turkmenistan.png": "257a",
	"./shiny/48/Turks-and-Caicos-Islands.png": "4c57",
	"./shiny/48/Tuvalu.png": "3a9e",
	"./shiny/48/US-Virgin-Islands.png": "819c",
	"./shiny/48/Uganda.png": "9ecf",
	"./shiny/48/Ukraine.png": "9e3b",
	"./shiny/48/United-Arab-Emirates.png": "2660",
	"./shiny/48/United-Kingdom.png": "17e5",
	"./shiny/48/United-Nations.png": "68db",
	"./shiny/48/United-States.png": "07ed",
	"./shiny/48/Unknown.png": "d819",
	"./shiny/48/Uruguay.png": "140e",
	"./shiny/48/Uzbekistan.png": "32b4",
	"./shiny/48/Vanuatu.png": "0ead",
	"./shiny/48/Vatican-City.png": "fdd1",
	"./shiny/48/Venezuela.png": "b538",
	"./shiny/48/Vietnam.png": "965df",
	"./shiny/48/Wales.png": "2e11",
	"./shiny/48/Wallis-And-Futuna.png": "a58a",
	"./shiny/48/Western-Sahara.png": "fd6b",
	"./shiny/48/Yemen.png": "56cd",
	"./shiny/48/Zambia.png": "5d5d",
	"./shiny/48/Zimbabwe.png": "4572",
	"./shiny/64/Abkhazia.png": "b3ed",
	"./shiny/64/Afghanistan.png": "4d3b",
	"./shiny/64/Aland.png": "6ce9",
	"./shiny/64/Albania.png": "7dfa",
	"./shiny/64/Algeria.png": "d978",
	"./shiny/64/American-Samoa.png": "049e",
	"./shiny/64/Andorra.png": "97e3",
	"./shiny/64/Angola.png": "317f",
	"./shiny/64/Anguilla.png": "404c",
	"./shiny/64/Antarctica.png": "fe08",
	"./shiny/64/Antigua-and-Barbuda.png": "42b1",
	"./shiny/64/Argentina.png": "feab",
	"./shiny/64/Armenia.png": "10b9",
	"./shiny/64/Aruba.png": "11f03",
	"./shiny/64/Australia.png": "7997",
	"./shiny/64/Austria.png": "e4ce",
	"./shiny/64/Azerbaijan.png": "f7dc",
	"./shiny/64/Bahamas.png": "a878",
	"./shiny/64/Bahrain.png": "9e67",
	"./shiny/64/Bangladesh.png": "7174",
	"./shiny/64/Barbados.png": "8490",
	"./shiny/64/Basque-Country.png": "cfc6",
	"./shiny/64/Belarus.png": "c5ae",
	"./shiny/64/Belgium.png": "571a",
	"./shiny/64/Belize.png": "faea",
	"./shiny/64/Benin.png": "7193",
	"./shiny/64/Bermuda.png": "e981",
	"./shiny/64/Bhutan.png": "51dc",
	"./shiny/64/Bolivia.png": "7224",
	"./shiny/64/Bosnia-and-Herzegovina.png": "d304",
	"./shiny/64/Botswana.png": "a9bf",
	"./shiny/64/Brazil.png": "84fb",
	"./shiny/64/British-Antarctic-Territory.png": "6d92",
	"./shiny/64/British-Virgin-Islands.png": "f9bd",
	"./shiny/64/Brunei.png": "bc7a7",
	"./shiny/64/Bulgaria.png": "7f4e",
	"./shiny/64/Burkina-Faso.png": "1549",
	"./shiny/64/Burundi.png": "9fb5",
	"./shiny/64/Cambodia.png": "cd7a",
	"./shiny/64/Cameroon.png": "6611",
	"./shiny/64/Canada.png": "ffe6",
	"./shiny/64/Canary-Islands.png": "2bc8",
	"./shiny/64/Cape-Verde.png": "7a04",
	"./shiny/64/Cayman-Islands.png": "3c86",
	"./shiny/64/Central-African-Republic.png": "e58f",
	"./shiny/64/Chad.png": "08934",
	"./shiny/64/Chile.png": "173b",
	"./shiny/64/China.png": "93be",
	"./shiny/64/Christmas-Island.png": "35d4",
	"./shiny/64/Cocos-Keeling-Islands.png": "2258",
	"./shiny/64/Colombia.png": "ec97",
	"./shiny/64/Commonwealth.png": "4d5e",
	"./shiny/64/Comoros.png": "6c7e",
	"./shiny/64/Cook-Islands.png": "7eeb",
	"./shiny/64/Costa-Rica.png": "37f4",
	"./shiny/64/Cote-dIvoire.png": "de4f",
	"./shiny/64/Croatia.png": "f4b0",
	"./shiny/64/Cuba.png": "432a",
	"./shiny/64/Curacao.png": "ba88",
	"./shiny/64/Cyprus.png": "d34d",
	"./shiny/64/Czech-Republic.png": "a369",
	"./shiny/64/Democratic-Republic-of-the-Congo.png": "1ea0",
	"./shiny/64/Denmark.png": "a8b1",
	"./shiny/64/Djibouti.png": "608e",
	"./shiny/64/Dominica.png": "1ec5",
	"./shiny/64/Dominican-Republic.png": "48c5",
	"./shiny/64/East-Timor.png": "51e0",
	"./shiny/64/Ecuador.png": "7c3b",
	"./shiny/64/Egypt.png": "0713",
	"./shiny/64/El-Salvador.png": "0bfe",
	"./shiny/64/England.png": "8df5",
	"./shiny/64/Equatorial-Guinea.png": "5567",
	"./shiny/64/Eritrea.png": "1165",
	"./shiny/64/Estonia.png": "6617",
	"./shiny/64/Ethiopia.png": "b802",
	"./shiny/64/European-Union.png": "4d6f",
	"./shiny/64/Falkland-Islands.png": "48a5",
	"./shiny/64/Faroes.png": "36f5",
	"./shiny/64/Fiji.png": "5a30",
	"./shiny/64/Finland.png": "8f47",
	"./shiny/64/France.png": "457f",
	"./shiny/64/French-Polynesia.png": "2ad37",
	"./shiny/64/French-Southern-Territories.png": "27a4",
	"./shiny/64/Gabon.png": "8f58",
	"./shiny/64/Gambia.png": "cb78",
	"./shiny/64/Georgia.png": "5be0",
	"./shiny/64/Germany.png": "63f9",
	"./shiny/64/Ghana.png": "c7fa",
	"./shiny/64/Gibraltar.png": "402eb",
	"./shiny/64/GoSquared.png": "94ee",
	"./shiny/64/Greece.png": "0d87",
	"./shiny/64/Greenland.png": "78cda",
	"./shiny/64/Grenada.png": "39b7",
	"./shiny/64/Guam.png": "8ded",
	"./shiny/64/Guatemala.png": "5494",
	"./shiny/64/Guernsey.png": "0b9ca",
	"./shiny/64/Guinea-Bissau.png": "6d31",
	"./shiny/64/Guinea.png": "fbb1",
	"./shiny/64/Guyana.png": "2a17",
	"./shiny/64/Haiti.png": "79bc6",
	"./shiny/64/Honduras.png": "8a81",
	"./shiny/64/Hong-Kong.png": "1d5b",
	"./shiny/64/Hungary.png": "e2b9",
	"./shiny/64/Iceland.png": "0655",
	"./shiny/64/India.png": "d471",
	"./shiny/64/Indonesia.png": "a629",
	"./shiny/64/Iran.png": "7e510",
	"./shiny/64/Iraq.png": "c0de",
	"./shiny/64/Ireland.png": "493e",
	"./shiny/64/Isle-of-Man.png": "2adf",
	"./shiny/64/Israel.png": "c19e8",
	"./shiny/64/Italy.png": "255a",
	"./shiny/64/Jamaica.png": "453f",
	"./shiny/64/Japan.png": "0d0a",
	"./shiny/64/Jersey.png": "f1da8",
	"./shiny/64/Jordan.png": "4de1",
	"./shiny/64/Kazakhstan.png": "88f3",
	"./shiny/64/Kenya.png": "5e01",
	"./shiny/64/Kiribati.png": "6057",
	"./shiny/64/Kosovo.png": "2adc",
	"./shiny/64/Kuwait.png": "01fa",
	"./shiny/64/Kyrgyzstan.png": "b289",
	"./shiny/64/Laos.png": "fe4d",
	"./shiny/64/Latvia.png": "de7f",
	"./shiny/64/Lebanon.png": "6cfc2",
	"./shiny/64/Lesotho.png": "a7e6",
	"./shiny/64/Liberia.png": "6fb1",
	"./shiny/64/Libya.png": "452a",
	"./shiny/64/Liechtenstein.png": "ae78",
	"./shiny/64/Lithuania.png": "12c3",
	"./shiny/64/Luxembourg.png": "19d8",
	"./shiny/64/Macau.png": "6e2d",
	"./shiny/64/Macedonia.png": "d912",
	"./shiny/64/Madagascar.png": "137d",
	"./shiny/64/Malawi.png": "496e",
	"./shiny/64/Malaysia.png": "7f84",
	"./shiny/64/Maldives.png": "2c5a",
	"./shiny/64/Mali.png": "5fd8",
	"./shiny/64/Malta.png": "92d5",
	"./shiny/64/Mars.png": "c17e",
	"./shiny/64/Marshall-Islands.png": "24e5",
	"./shiny/64/Martinique.png": "b686",
	"./shiny/64/Mauritania.png": "2861",
	"./shiny/64/Mauritius.png": "37b6",
	"./shiny/64/Mayotte.png": "374c",
	"./shiny/64/Mexico.png": "87fe",
	"./shiny/64/Micronesia.png": "455fa",
	"./shiny/64/Moldova.png": "6a79",
	"./shiny/64/Monaco.png": "991a",
	"./shiny/64/Mongolia.png": "8ae9",
	"./shiny/64/Montenegro.png": "c940",
	"./shiny/64/Montserrat.png": "3097",
	"./shiny/64/Morocco.png": "26e9",
	"./shiny/64/Mozambique.png": "1657",
	"./shiny/64/Myanmar.png": "69ec",
	"./shiny/64/NATO.png": "d142",
	"./shiny/64/Nagorno-Karabakh.png": "6821e",
	"./shiny/64/Namibia.png": "0e98",
	"./shiny/64/Nauru.png": "9e2f",
	"./shiny/64/Nepal.png": "624d",
	"./shiny/64/Netherlands-Antilles.png": "4fb8",
	"./shiny/64/Netherlands.png": "63ad9",
	"./shiny/64/New-Caledonia.png": "f6c2",
	"./shiny/64/New-Zealand.png": "0abc",
	"./shiny/64/Nicaragua.png": "baae",
	"./shiny/64/Niger.png": "c097",
	"./shiny/64/Nigeria.png": "2705",
	"./shiny/64/Niue.png": "285a",
	"./shiny/64/Norfolk-Island.png": "6002",
	"./shiny/64/North-Korea.png": "2a84",
	"./shiny/64/Northern-Cyprus.png": "834c",
	"./shiny/64/Northern-Mariana-Islands.png": "fb8d",
	"./shiny/64/Norway.png": "efe4",
	"./shiny/64/Olympics.png": "8b4c",
	"./shiny/64/Oman.png": "0b31",
	"./shiny/64/Pakistan.png": "938e",
	"./shiny/64/Palau.png": "92e8",
	"./shiny/64/Palestine.png": "6173",
	"./shiny/64/Panama.png": "1868",
	"./shiny/64/Papua-New-Guinea.png": "7f77",
	"./shiny/64/Paraguay.png": "056e",
	"./shiny/64/Peru.png": "83d3",
	"./shiny/64/Philippines.png": "686c",
	"./shiny/64/Pitcairn-Islands.png": "6766",
	"./shiny/64/Poland.png": "840a",
	"./shiny/64/Portugal.png": "28d7",
	"./shiny/64/Puerto-Rico.png": "28be",
	"./shiny/64/Qatar.png": "c358",
	"./shiny/64/Red-Cross.png": "8efd",
	"./shiny/64/Republic-of-the-Congo.png": "f64d",
	"./shiny/64/Romania.png": "6809",
	"./shiny/64/Russia.png": "006e",
	"./shiny/64/Rwanda.png": "0a8c",
	"./shiny/64/Saint-Barthelemy.png": "d0bc",
	"./shiny/64/Saint-Helena.png": "863c",
	"./shiny/64/Saint-Kitts-and-Nevis.png": "9370",
	"./shiny/64/Saint-Lucia.png": "a358",
	"./shiny/64/Saint-Martin.png": "8d9c",
	"./shiny/64/Saint-Vincent-and-the-Grenadines.png": "613c",
	"./shiny/64/Samoa.png": "d249",
	"./shiny/64/San-Marino.png": "3307",
	"./shiny/64/Sao-Tome-and-Principe.png": "539e",
	"./shiny/64/Saudi-Arabia.png": "88ea",
	"./shiny/64/Scotland.png": "57ee",
	"./shiny/64/Senegal.png": "41e0",
	"./shiny/64/Serbia.png": "38fb",
	"./shiny/64/Seychelles.png": "1b13",
	"./shiny/64/Sierra-Leone.png": "d07f",
	"./shiny/64/Singapore.png": "5484",
	"./shiny/64/Slovakia.png": "910d",
	"./shiny/64/Slovenia.png": "32c9",
	"./shiny/64/Solomon-Islands.png": "7994",
	"./shiny/64/Somalia.png": "63e1",
	"./shiny/64/Somaliland.png": "0c56",
	"./shiny/64/South-Africa.png": "4786",
	"./shiny/64/South-Georgia-and-the-South-Sandwich-Islands.png": "abda",
	"./shiny/64/South-Korea.png": "4637",
	"./shiny/64/South-Ossetia.png": "87b2",
	"./shiny/64/South-Sudan.png": "fdc9",
	"./shiny/64/Spain.png": "7a28",
	"./shiny/64/Sri-Lanka.png": "b01d",
	"./shiny/64/Sudan.png": "7ee0",
	"./shiny/64/Suriname.png": "468c",
	"./shiny/64/Swaziland.png": "47af",
	"./shiny/64/Sweden.png": "1fb7",
	"./shiny/64/Switzerland.png": "e7ce",
	"./shiny/64/Syria.png": "c41b",
	"./shiny/64/Taiwan.png": "25dc",
	"./shiny/64/Tajikistan.png": "dd2f",
	"./shiny/64/Tanzania.png": "76c1",
	"./shiny/64/Thailand.png": "290b",
	"./shiny/64/Togo.png": "a6dc",
	"./shiny/64/Tokelau.png": "1c2c",
	"./shiny/64/Tonga.png": "c51b",
	"./shiny/64/Trinidad-and-Tobago.png": "ee9f",
	"./shiny/64/Tunisia.png": "b762",
	"./shiny/64/Turkey.png": "44aa",
	"./shiny/64/Turkmenistan.png": "633f",
	"./shiny/64/Turks-and-Caicos-Islands.png": "aa93",
	"./shiny/64/Tuvalu.png": "6268",
	"./shiny/64/US-Virgin-Islands.png": "a3a3",
	"./shiny/64/Uganda.png": "ccc6",
	"./shiny/64/Ukraine.png": "5cca",
	"./shiny/64/United-Arab-Emirates.png": "adaa",
	"./shiny/64/United-Kingdom.png": "b623",
	"./shiny/64/United-Nations.png": "bea0",
	"./shiny/64/United-States.png": "232c",
	"./shiny/64/Unknown.png": "cb86",
	"./shiny/64/Uruguay.png": "094f",
	"./shiny/64/Uzbekistan.png": "d450",
	"./shiny/64/Vanuatu.png": "ec78",
	"./shiny/64/Vatican-City.png": "c6a6",
	"./shiny/64/Venezuela.png": "7fdf",
	"./shiny/64/Vietnam.png": "7f4d",
	"./shiny/64/Wales.png": "0324",
	"./shiny/64/Wallis-And-Futuna.png": "8d745",
	"./shiny/64/Western-Sahara.png": "7c9e",
	"./shiny/64/Yemen.png": "3f99",
	"./shiny/64/Zambia.png": "db04",
	"./shiny/64/Zimbabwe.png": "e896",
	"./th.png": "0d00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";